export const de_strings = {
  'err.pattern.^0[1-9]\\d{6,14}$': 'Die Nummer muss mit 0 beginnen, gefolgt von einer Ziffer zwischen 1 und 9 und dann 6 bis 14 weiteren Ziffern.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ\' .\-]*$': 'Das Feld "{fieldName}" darf nur Buchstaben, Akzente, Leerzeichen, Apostrophe, Punkte und Bindestriche enthalten.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\\s\\-\\.\'\(\)]*$': 'Das Feld "{fieldName}" darf nur Buchstaben, Zahlen, Akzente, Leerzeichen, Bindestriche, Punkte, Apostrophe und Klammern enthalten.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-\\s]+$': 'Das Feld "{fieldName}" darf nur Buchstaben, Zahlen, Akzente, Leerzeichen, Apostrophe, Punkte, Klammern und Bindestriche enthalten.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\'.,\(\)\- ]*$': 'Das Feld "{fieldName}" darf nur Buchstaben, Zahlen, Akzente, Leerzeichen, Apostrophe, Kommas, Punkte, Klammern und Bindestriche enthalten.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]*$': 'Das Feld "{fieldName}" darf nur Buchstaben, Zahlen, Akzente, Leerzeichen, Apostrophe, Punkte, Klammern und Bindestriche enthalten.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .\(\)\-]+$': 'Das Feld "{fieldName}" darf nur Buchstaben, Zahlen, Akzente, Leerzeichen, Apostrophe, Punkte, Klammern und Bindestriche enthalten.',
  'tooltip.allNotes': 'Alle Notizen anzeigen',
  'tooltip.openDuplicate': 'Letzte Duplikat-Zahlung öffnen',
  'payment.openDuplicate': 'Das Duplikat öffnen',
  'err.pattern.password': 'Das Passwort muss mindestens zwei der folgenden enthalten: einen Kleinbuchstaben, einen Großbuchstaben, eine Zahl oder ein Sonderzeichen.',
  'form.perm1.DYN.': 'Eine Anwendung erstellen',
  'global.pay': 'Bezahlen',
  'smartTable.timeslot': 'Zeitfenster',
  'smartTable.requestReason': 'Antragsgrund',
  'smartTable.passportType': 'Reisepasstyp',
  'BirthCity': 'Geburtsstadt',
  'smartTable.timeslotPlaceId': 'Timeslot-Ort',
  'err.pattern.^\\+[1-9][0-9]{7,14}$': 'Das Feld "{fieldName}" muss mit einem "+" gefolgt von 8 bis 15 Ziffern beginnen.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .()\\-]*$': 'Das Feld "{fieldName}" darf nur Buchstaben, Zahlen, Akzente, Leerzeichen, Apostrophe, Punkte, Klammern und Bindestriche enthalten.',
  'refusalReason.desc.DYN.': '<p>Bitte geben Sie eine kurze Beschreibung des Ablehnungsgrundes an.</p>',
  'timezone.notice': 'Termine werden basierend auf der Zeitzone des Terminortes geplant.',
  'timeslot.noBooking': 'Es wurde kein Buchungszeitfenster ausgewählt.',
  'timeslot.tooCloseToChange': 'Sie können diesen Termin nicht mehr ändern, da er in weniger als {hours} Stunden stattfindet.',
  'session.inactive.title': 'Session inactive',
  'session.inactive': 'Ihre Sitzung ist wegen Inaktivität abgelaufen.',
  'reactivateSession': 'Sitzung reaktivieren',
  'global.changeTimeSlot': 'Termin ändern',
  'outUsage.AB': 'Diese Anwendung ist <b>außerhalb ihrer Gültigkeitsdauer</b>. Bitte leiten Sie den Antragsteller zum Kiosk oder unterstützen Sie ihn bei der erneuten Einreichung seines Antrags.',
  'outUsage.C': 'Diese Anwendung ist <b>außerhalb ihrer Gültigkeitsdauer</b>. Bitte schließen Sie diese Anfrage, erstellen Sie dann einen neuen Eintrag für den Antragsteller und fahren Sie mit der Ablehnung fort.',
  'err.payment.notAvailable': 'Diese Anwendung ist nicht verfügbar.',
  'form.PlaceOfBirth': 'Geburtsort',
  'borderPass': 'Grenzpass',
  'urgent_pass': 'Dringender Reisepass',
  'feedback': 'Feedback',
  'err.mustBeDifferentThan.errorValue': 'Das Feld "{fieldName}" muss unterschiedlich von {errorValue} sein.',
  'DYN.PASSPORT_WRONG': 'Falscher Reisepass',
  'err.max.errorValue': 'Das Feld "{fieldName}" muss kleiner als {errorValue} sein.',
  'err.max': 'Das Feld „{fieldName}“ muss kleiner als der zulässige Höchstwert sein.',
  'err.min.errorValue': 'Das Feld "{fieldName}" muss größer als {errorValue} sein.',
  'err.min': 'Das Feld „{fieldName}“ muss größer als der zulässige Mindestwert sein.',
  'updateField.desc': 'Bitte geben Sie die aktualisierten Informationen für das folgende Feld ein: <b>{field}</b>',
  'marital.status.engaged': 'Verheiratet',
  'payment_status.desc.DYN.passport_booked.toPay': 'Die Anfrage für das Dokument wurde reserviert und muss noch bezahlt werden.',
  'payment_status.desc.DYN.passport_booked': 'Die Anfrage für das Dokument wurde reserviert und bezahlt.',
  'place.notExist': 'Der Ort existiert nicht',
  'ApplicationForm': 'Antragsformular',
  'BirthCertificate': 'Geburtsurkunde',
  'ParentalAuthorization': 'Elterngenehmigung',
  'printSettings.selected': 'Sie ändern die Druckeinstellungen für das Dokument: <b>{documentName}</b>',
  'print.settings.success': 'Die Druckeinstellungen wurden erfolgreich für das Dokument aktualisiert: <b>{documentName}</b>',
  'error.noHasFace': 'Auf dem Foto wurde kein Gesicht erkannt. Bitte machen Sie das Foto erneut.',
  'name.warn': 'Der Vorname und/oder der Nachname ist leer oder enthält weniger als 2 Zeichen.',
  'kiosk.redirect': 'Ihre Staatsangehörigkeit erlaubt kein Fortfahren im Kioskmodus. Bitte melden Sie sich mit einem Konto an, um fortzufahren. Sie werden zum Anmeldebildschirm weitergeleitet.',
  'err.OtherPurpose.required': 'Anderer Zweck ist erforderlich',
  'print.qr.verification': 'Verifizierung',
  'print.qr.application': 'Antrag',
  'print.terms': 'Es gelten die Allgemeinen Geschäftsbedingungen.',
  'movements.empty': 'Es wurden noch keine Bewegungen erfasst.',
  'movement.history': 'Ein-/Ausreiseverlauf',
  'payment.notes': 'Notizen',
  'payment.noNotes': 'Keine Notizen vorhanden',
  'extension.alreadyExists.warning': 'Für diesen Antrag existiert bereits eine Verlängerung. Sind Sie sicher, dass Sie eine neue erstellen möchten?',
  'payment.addNote.placeholder': 'Eine Notiz hinzufügen…',
  'global.seeMore': 'Mehr anzeigen',
  'global.seeLess': 'Weniger anzeigen',
  'downgrade.type.label': 'Zielvisumtyp',
  'ask.downgradeType': 'Wählen Sie den Typ des Zielvisums',
  'err.approveRefuse.required': 'Bitte wählen Sie, ob Sie empfehlen möchten oder nicht.',
  'ask.downgrade.multiple': 'Sind Sie sicher, dass Sie dieses Visum auf {type} herabstufen möchten?',
  'PreviousVisa': 'Vorheriges Visum',
  'multipleEntry.warning': 'Achtung: Mehrfacheinreisevisa werden nur Personen gewährt, die in der Vergangenheit mindestens ein gültiges Visum erhalten haben. Eine Kopie eines vorherigen Visums wird verlangt.',
  'err.PreviousVisa.required': 'Vorheriges Visum ist erforderlich',
  'err.hostPhone.pattern': 'Die Telefonnummer muss mit + (Landesvorwahl) oder 0 beginnen und zwischen 7 und 15 Ziffern enthalten.',
  'reprintSticker': 'Sticker erneut drucken',
  'err.daysGranted.min': 'Die Anzahl der Tage muss mindestens 1 betragen.',
  'err.daysGranted.max': 'Die Anzahl der Tage darf die beantragten Tage nicht überschreiten.',
  'err.daysGranted.required': 'Die Anzahl der Tage ist erforderlich.',
  'approval.daysGranted.error': 'Bitte geben Sie eine gültige Anzahl von Tagen ein.',
  'err.password.pattern': 'Das Passwort muss mindestens zwei der folgenden enthalten: einen Kleinbuchstaben, einen Großbuchstaben, eine Zahl oder ein Sonderzeichen.',
  'err.documentNumber.pattern': 'Die Dokumentnummer darf nur Buchstaben, Zahlen, Leerzeichen und Bindestriche enthalten.',
  'ask.borderpass': 'Ist es wirklich ein Grenzpass?',
  'err.ExistingValidEntryReference.required': 'Bestehende gültige Eintragsreferenz ist erforderlich',
  'BirthCountry': 'Geburtsland',
  'old': 'Altes Passwort',
  'firstName': 'Vorname',
  'email': 'Email',
  'paymentMethod': 'Zahlungsmethode',
  'client.extended.softLockedOutLogin30Minutes': 'Sie wurden 30 Minuten gesperrt. Bitte versuchen Sie es erneut.',
  'password': 'Passwort',
  'password2': 'Passwort bestätigen',
  'PreviousConvictions': 'Vorbestrafungen',
  'Address': 'Adresse',
  'err.err': 'Fehler',
  'err.maxDateMilliFrom.errorValue': 'Das Feld "{fieldName}" darf den Grenzwert "{errorValue}" nicht überschreiten, der im Feld "{control}" definiert ist.',
  'err.maxDateMilliTo.errorValue': 'Das Feld "{fieldName}" muss vor dem Grenzwert "{errorValue}" liegen, der im Feld "{control}" definiert ist.',
  'err.mustBeEqualOrAfter.errorValue': 'Das Feld "{fieldName}" muss gleich oder später als das Feld "{errorValue}" sein.',
  'err.mustBeEqualOrBefore.errorValue': 'Das Feld "{fieldName}" muss gleich oder früher als das Feld "{errorValue}" sein.',
  'err.maxDateMilliFromToday.errorValue': 'Das Feld "{fieldName}" darf den {errorValue} nicht überschreiten.',
  'err.minDateMilliFromNow.errorValue': 'Das Feld "{fieldName}" muss ein Datum sein, das gleich oder nach dem {errorValue} liegt.',
  'err.maxDateMilliFromNow.errorValue': 'Das Feld "{fieldName}" muss ein Datum sein, das gleich oder vor dem {errorValue} liegt.',
  'err.minDateMilliFromNow': 'Das Feld "{fieldName}" muss ein Datum sein, das gleich oder nach dem zulässigen Mindestdatum liegt.',
  'err.maxDateMilliFromNow': 'Das Feld "{fieldName}" muss ein Datum sein, das gleich oder vor dem zulässigen Höchstdatum liegt.',
  'err.mustMatch': 'Das Feld {fieldName} muss mit dem entsprechenden Feld übereinstimmen.',
  'err.requireOneOf.errorValue': '{errorValue} muss angegeben werden',
  'err.requireOneOf.field': 'Das Feld \'{name}\'',
  'err.requireOneOf.separator': ' oder ',
  'err.pattern.^[0-9]{6,14}$': 'Das Feld "{fieldName}" muss zwischen 6 und 14 Ziffern enthalten.',
  'err.patten.^[0-9A-Za-z\\-\\s]{3,15}$': 'Das Feld "{fieldName}" muss zwischen 3 und 15 alphanumerische Zeichen, Bindestriche oder Leerzeichen enthalten.',
  'err.pattern.^[+]?[0-9\\s\\-\\(\\)]{7,20}$': 'Das Feld "{fieldName}" muss zwischen 7 und 20 Zeichen enthalten: Ziffern, Leerzeichen, Bindestriche oder Klammern.',
  'err.pattern.^[0-9A-Za-z]{5,20}$': 'Das Feld "{fieldName}" muss zwischen 5 und 20 alphanumerische Zeichen enthalten.',
  'err.pattern.^[0-9]{10}$': 'Das Feld "{fieldName}" muss genau 10 Ziffern enthalten.',
  'err.pattern.^[0-9A-Za-z]{5,20}': 'Das Feld "{fieldName}" muss zwischen 5 und 20 alphanumerische Zeichen enthalten.',
  'err.pattern.^[0-9]{8,20}$': 'Das Feld "{fieldName}" muss zwischen 8 und 20 Ziffern enthalten.',
  'err.pattern.^[A-Za-z0-9]{5,15}$': 'Das Feld "{fieldName}" muss zwischen 5 und 15 alphanumerische Zeichen enthalten.',
  'err.pattern.^((?:data:image/(jp2|jpeg);base64,)*([A-Za-z0-9+/==]+))': 'Das Feld "{fieldName}" muss ein gültiges base64-kodiertes JPEG- oder JP2-Bild sein.',
  'err.pattern.^[a-z]$': 'Das Feld "{fieldName}" darf nur einen Kleinbuchstaben enthalten.',
  "err.pattern.^[A-Z' -]*$": 'Das Feld "{fieldName}" darf nur Großbuchstaben, Apostrophe, Leerzeichen und Bindestriche enthalten.',
  'err.pattern.^[0-9-]{6,15}$': 'Das Feld "{fieldName}" muss zwischen 6 und 15 Zeichen enthalten (nur Ziffern und Bindestriche).',
  'err.pattern.^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$': 'Das Feld "{fieldName}" muss eine gültige E-Mail-Adresse enthalten.',
  'err.pattern.^(?:data:image/(jpeg|png|webp);base64,|data:application/pdf;base64,)*([A-Za-z0-9+/==]+)$': 'Das Feld "{fieldName}" muss ein gültiges base64-kodiertes JPEG-, PNG-, WebP-Bild oder ein PDF-Dokument sein.',
  'err.pattern.^[A-Z]{3}$': 'Das Feld "{fieldName}" muss genau drei Großbuchstaben enthalten.',
  'err.pattern.^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,9}$': 'Das Feld "{fieldName}" muss eine gültige Telefonnummer enthalten; Vorwahl erlaubt, Leerzeichen, Bindestriche oder Punkte möglich.',
  'err.pattern.^(?:\\+[1-9]\\d{6,14}|0\\d{6,14})$': 'Das Feld "{fieldName}" muss eine gültige internationale oder nationale Telefonnummer enthalten (z.B. +1234567890 oder 0123456789).',
  'err.pattern.^[A-Za-z\\s\\-]+$': 'Das Feld "{fieldName}" darf nur Buchstaben, Leerzeichen und Bindestriche enthalten.',
  "err.pattern.^[a-zA-Z' -]*$": 'Das Feld "{fieldName}" darf nur Buchstaben, Leerzeichen und Bindestriche enthalten.',
  'err.pattern.^[A-Za-z0-9\\s\\-]+$': 'Das Feld "{fieldName}" darf nur Buchstaben, Zahlen, Leerzeichen und Bindestriche enthalten.',
  'err.pattern.^[0-9]*$': 'Das Feld "{fieldName}" muss nur Ziffern enthalten.',
  'err.pattern.^[0-9]{4}-[0-9]{2}-[0-9]{2}$': 'Das Feld "{fieldName}" muss eine gültige Datumsangabe enthalten.',
  'err.pattern.^[A-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ][a-zA-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ\\-. ]*$': 'Das Feld "{fieldName}" muss mit einem Großbuchstaben beginnen und darf nur Kleinbuchstaben, Akzente, Leerzeichen, Apostrophe, Bindestriche oder Punkte enthalten.',
  'err.pattern.^[A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒàáâãäåçèéêëìíîïòóôõöùúûüæœ\\-. ]*$': 'Das Feld "{fieldName}" muss nur Buchstaben (mit oder ohne Akzente), Leerzeichen, Apostrophe, Bindestriche oder Punkte enthalten.',
  'err.pattern.^[A-Z0-9]+$': 'Das Feld "{fieldName}" darf nur Großbuchstaben und Zahlen enthalten.',
  'err.pattern.^(?:\\+[1-9]\\d{0,3})$': 'Das Feld "{fieldName}" muss mit einem "+" beginnen, gefolgt von 1 bis 4 Ziffern (die erste Ziffer darf nicht 0 sein).',
  'err.required': 'Das Feld "{fieldName}" ist erforderlich.',
  'err.maxlength.errorValue': 'Das Feld "{fieldName}" darf maximal {errorValue} Zeichen enthalten.',
  'err.minlength.errorValue': 'Das Feld "{fieldName}" muss mindestens {errorValue} Zeichen enthalten.',
  'err.maxlength': 'Das Feld "{fieldName}" ist zu lang.',
  'err.minlength': 'Das Feld "{fieldName}" ist zu kurz.',
  'err.pattern': 'Das Feld "{fieldName}" hat ein ungültiges Format.',
  'err.email': 'Das Feld "{fieldName}" muss eine gültige E-Mail-Adresse enthalten.',
  'form.lang.EN': 'English',
  'form.lang.FR': 'Français',
  'form.lang.AR': 'عربي',
  'form.lang.PT': 'Português',
  'form.lang.DE': 'Deutsch',
  'form.lang.RU': 'Русский',
  'form.lang.CN': '中文',
  'successPayment.booking.title': 'Buchung bestätigt!',
  'global.bookTimeSlot': 'Zeitslot buchen',
  'client.extended.maxMonthlyPaymentsReached': 'Sie haben die maximale Anzahl an monatlichen Zahlungen erreicht. Bitte wenden Sie sich an den Support.',
  'calendar.weekday.sunday': 'So',
  'calendar.weekday.monday': 'Mo',
  'calendar.weekday.tuesday': 'Di',
  'calendar.weekday.wednesday': 'Mi',
  'calendar.weekday.thursday': 'Do',
  'calendar.weekday.friday': 'Fr',
  'calendar.weekday.saturday': 'Sa',
  'calendar.month.january': 'Januar',
  'calendar.month.february': 'Februar',
  'calendar.month.march': 'März',
  'calendar.month.april': 'April',
  'calendar.month.may': 'Mai',
  'calendar.month.june': 'Juni',
  'calendar.month.july': 'Juli',
  'calendar.month.august': 'August',
  'calendar.month.september': 'September',
  'calendar.month.october': 'Oktober',
  'calendar.month.november': 'November',
  'calendar.month.december': 'Dezember',
  'calendar.timeline.no_slots': 'Keine Zeitfenster für diesen Tag verfügbar',
  'calendar.timeline.available': 'Verfügbar',
  'calendar.timeline.spots_available': 'Plätze verfügbar',
  'calendar.timeline.fully_booked': 'Vollständig gebucht',
  'calendar.confirm_booking_title': 'Buchung bestätigen',
  'calendar.confirm_booking_message': 'Bitte bestätigen Sie, dass Sie diesen Zeitslot buchen möchten.',
  'calendar.booking_in_progress': 'Buchung läuft...',
  'calendar.please_wait': 'Bitte warten Sie, während wir Ihre Buchung bearbeiten.',
  'calendar.booking_error_title': 'Buchungsfehler',
  'calendar.booking_success_title': 'Buchung bestätigt!',
  'calendar.booking_success_message': 'Ihr Zeitslot wurde erfolgreich reserviert.',
  'calendar.proceed_to_payment': 'Zur Zahlung',
  'calendar.auto_proceed_message': 'Automatische Weiterleitung in...',
  'calendar.date': 'Datum',
  'calendar.time': 'Zeit',
  'calendar.place': 'Ort',
  'calendar.loading_month': 'Verfügbarkeit wird geladen...',
  'extension.error.maxDays': 'Sie können nicht mehr als 30 Tage pro Verlängerung beantragen.',
  'DYN.processed.NOTICES_ACCEPTED': 'Mitteilungen bestätigt',
  'notices_validated': 'Mitteilungen bestätigt',
  'err.daysUntilReport.pattern': 'Die Anzahl der Tage bis zum Bericht muss ein korrektes Format haben',
  'err.reportInterval.pattern': 'Der Berichtsintervall muss eine Zahl größer oder gleich 0 sein',
  'err.CompanionsSize.min': 'Die Anzahl der Begleitpersonen muss mindestens 1 sein',
  'err.CompanionsSize.max': 'Die Anzahl der Begleitpersonen ist zu lang',
  'global.error': 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut. Wenn das Problem besteht, wenden Sie sich bitte an den Support.',
  'err.DurationOfStay.required': 'Die Dauer der Aufenthaltsdauer ist erforderlich',
  'err.DurationOfStay.min': 'Die Dauer der Aufenthaltsdauer muss mindestens 1 Tag betragen',
  'err.DurationOfStay.max': 'Die Dauer der Aufenthaltsdauer ist zu lang',
  'DurationOfStay': 'Dauer der Aufenthaltsdauer (Tage)',
  'tooltip.acceptNotices': 'Die aktuelle Mitteilung bestätigen',
  'notices': 'Mitteilungen',
  'ask.notices': 'Möchten Sie die Mitteilung bestätigen?',
  'accept.notices': 'Mitteilung bestätigen',
  'err.ModeOfTravel.required': 'Modus der Reise ist erforderlich',
  'err.FlightNumber.required': 'Flugnummer ist erforderlich',
  'err.ShipNumber.required': 'Schiffnummer ist erforderlich',
  'err.CarNumber.required': 'Fahrzeugnummer ist erforderlich',
  'err.BusNumber.required': 'Busnummer ist erforderlich',
  'err.TrainNumber.required': 'Zugnummer ist erforderlich',
  'err.FlightNumber.pattern': 'Flugnummer muss ein korrektes Format haben',
  'err.ShipNumber.pattern': 'Schiffnummer muss ein korrektes Format haben',
  'err.CarNumber.pattern': 'Fahrzeugnummer muss ein korrektes Format haben',
  'err.BusNumber.pattern': 'Busnummer muss ein korrektes Format haben',
  'err.TrainNumber.pattern': 'Zugnummer muss ein korrektes Format haben',
  'ModeOfTravel': 'Modus der Reise',
  'FlightNumber': 'Flugnummer',
  'ShipNumber': 'Schiffnummer',
  'CarNumber': 'Fahrzeugnummer',
  'BusNumber': 'Busnummer',
  'TrainNumber': 'Zugnummer',
  'DYN.flight': 'Flug',
  'DYN.ship': 'Schiff',
  'DYN.car': 'Fahrzeug',
  'DYN.bus': 'Bus',
  'DYN.train': 'Zug',
  'DYN.foot': 'Fuß',
  'open.register': 'Register öffnen',
  'supervision.nofee': 'Bestätigung durch einen Vorgesetzten ist für eine gebührenfreie Anfrage erforderlich.',
  'NoFeeProof': 'Gebührenbefreiungsnachweis',
  'webcam.nofeeProof.confirm': 'Bitte fotografieren Sie das Dokument zur Gebührenbefreiung (No Fee Proof).',
  'expiredSinceTime': 'Der Antrag ist seit <b>{days} Tagen und {hours} Stunden</b> abgelaufen.',
  'ask.isArrivalPaid.confirm': 'Bestätigen Sie, dass die Zahlung erfolgt ist? Wenn ja, geben Sie bitte die Zahlungsreferenz, die Zahlungsmethode und die verwendete Währung ein. Sie können auch das maximale Abreisedatum ändern (Sie können das Datum nur verkürzen, und zwar auf einen Zeitraum zwischen 1 und {days} Tagen).',
  'smartTable.filter.sinceDays': 'Seit',
  'smartTable.filter.createAtStart': 'Startdatum',
  'smartTable.filter.createAtEnd': 'Enddatum',
  'smartTable.filter.timeslotStart': 'Zeitslot (Start)',
  'smartTable.filter.timeslotEnd': 'Zeitslot (Ende)',
  'smartTable.filter.paymentExtStatus': 'Status der Verlängerung',
  'smartTable.filter.paymentStatus': 'Antragsstatus',
  'smartTable.filter.overstay': 'Überbleiben',
  'smartTable.filter.isUrgent': 'Dringend',
  'smartTable.filter.applicationType': 'Antragstyp',
  'smartTable.operationId': 'Dokumenttyp',
  'smartTable.usageUntil': 'Gültig bis',
  'smartTable.usageAfter': 'Gültig ab',
  'smartTable.price': 'Preis',
  'smartTable.paymentStatus': 'Zahlungsstatus',
  'smartTable.isUrgent': 'Dringend',
  'smartTable.passportNumber': 'Passierschein-Nummer',
  'smartTable.fullName': 'Vollständiger Name',
  'smartTable.lastName': 'Nachname',
  'smartTable.firstName': 'Vorname',
  'smartTable.batchId': 'Antragsreferenz',
  'smartTable.nationality': 'Nationalität',
  'smartTable.internalReference': 'Hauptquartier Referenz',
  'smartTable.lock': 'Sperre',
  'smartTable.applicationId': 'Antrag-ID',
  'smartTable.creationDate': 'Erstellungsdatum',
  'smartTable.email': 'E-Mail',
  'smartTable.role': 'Rolle',
  'smartTable.name': 'Name',
  'smartTable.userId': 'Benutzer-ID',
  'smartTable.id': 'ID',
  'smartTable.placeId': 'ID-Platz',
  'total': 'Gesamt',
  'onlyFinalReview': 'Diese Anwendung wartet auf die finale Prüfung.',
  'tooltip.consumeOfficer.OUT': 'Der Beamte, der die Person ausgecheckt hat.',
  'tooltip.consumeOfficer.IN': 'Der Beamte, der die Person eingecheckt hat.',
  'DYN.document.OTHER': 'Dokument',
  'DYN.document.IR': 'Aufenthaltserlaubnis',
  'DYN.document.D': 'Fahrer',
  'DYN.document.ID': 'Ausweis',
  'DYN.document.P': 'Passierschein',
  'scanned': 'Gescannt',
  'DYN.form.documentNumber.scanned': '{document} Nummer',
  'ask.isExtension.confirm': 'Bestätigen Sie bitte, dass die Zahlung erfolgt ist. Wenn Sie bestätigen, geben Sie bitte die Zahlungsreferenz, die Zahlungsmethode und die verwendete Währung ein.',
  'payment_status.desc.DYN.8.review': 'Dieser Antrag wird derzeit von der Aufsichtsbehörde geprüft.',
  'payment_status.DYN.8.review': 'Wartet auf Überprüfung',
  'DYN.role.5': 'Kiosk',
  'DYN.role.4': 'Partnerregister',
  'DYN.role.3': 'Administrator',
  'DYN.role.2': 'Orbis-Kunde',
  'DYN.role.1': 'Mitarbeiter',
  'DYN.role.0': 'Kunde',
  'DYN.role.6': 'Externer Beobachter',
  'info.readingPayment': 'Ausführliche Informationen vom Server laden...',
  'info.searchingPayment': 'Suche nach Anwendung auf Servern...',
  'info.convertingImage': 'Bild aus Dokument konvertieren...',
  'info.disconnect': 'Trennen...',
  'info.readingDG': 'Datengruppen werden gelesen...',
  'info.doingPA': 'Passive-Authentifizierung durchführen...',
  'info.readingCertificate': 'Zertifikat signieren...',
  'info.testingBAC': 'Grundlegende Zugriffskontrolle wird durchgeführt...',
  'info.connecting': 'Verbindung zum Chip herstellen...',
  'info.readingMrz': 'MRZ wird gelesen...',
  'info.testingReaderCard': 'Überprüfung, ob sich eine Chipkarte im Lesegerät befindet...',
  'info.testingReader': 'Prüfung der Leseranwesenheit...',
  'tooltip.prepareLandingVisa': 'Landevisa vorbereiten',
  'printEventsCollapse': 'Alle Druckereignisse dieser Anwendung',
  'tooltip.printEvents': 'Eine Liste aller Druckereignisse dieser Anwendung',
  'approval.daysGranted.DYN.': 'Anzahl der gewährten Tage',
  'ask.closeApplication': 'Diese Aktion kann verwendet werden, wenn ein Reisender Nachweis erbringen kann, dass eine Operation offline abgeschlossen wurde, wodurch dieser Eintrag als gelöst und verworfen betrachtet werden kann. Bitte bestätigen Sie, dass Sie diese Anfrage schließen möchten. Diese Aktion ist endgültig und kann nicht rückgängig gemacht werden.',
  'done.closeApplication': 'Die Anwendung wurde erfolgreich geschlossen. Möchten Sie eine neue Anwendung basierend auf dieser erstellen?',
  'documents.load': 'Alle Dokumente laden',
  'documents.add': 'Fehlendes Dokument hinzufügen',
  'print.extension': 'Druckverlängerung',
  'open.visaReference': 'Verknüpfte Anwendung öffnen',
  'error.updatePassport': 'Beim Aktualisieren der Anwendung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'supervision.catC.ordinary.refuse': 'ZUGANG VERWEIGERT',
  'supervision.catC.ordinary.entry': 'CHECK-IN',
  'ExistingValidEntryReference': 'Bestehende gültige Eintragsreferenz',
  'existingValidEntryReference.desc': 'Diese Anwendung enthält eine <b>gültige Einreisebezug</b>. Das bedeutet, dass der Reisende bereits bezahlt und die Einreise erteilt wurde. Bitte stellen Sie sicher, dass die Gültigkeit der Referenz überprüft wird, bevor Sie fortfahren. Wenn alles korrekt ist, können Sie mit der Check-in-Verarbeitung fortfahren.',
  'no.must_pay': 'Zahlung noch erforderlich',
  'continue': 'Weiter',
  'global.changePassword': 'Passwort ändern',
  'signIn.forgotPassword': 'Passwort vergessen',
  'signIn.title': 'Anmelden',
  'global.notAccount': 'Noch kein Konto?',
  'global.continue': 'Weiter',
  'Occupation': 'Beruf',
  'signUp.title': 'Konto erstellen',
  'DYN.selectedPaymentMethod.VISA': 'Sie haben ausgewählt, mit <b>Visa</b> zu bezahlen.',
  'DYN.selectedPaymentMethod.MASTERCARD': 'Sie haben ausgewählt, mit <b>Mastercard</b> zu bezahlen.',
  'DYN.selectedPaymentMethod.AMERICAN_EXPRESS': 'Sie haben ausgewählt, mit <b>American Express</b> zu bezahlen.',
  'DYN.selectedPaymentMethod.DINERS_CLUB': 'Sie haben ausgewählt, mit <b>Diner\'s Club</b> zu bezahlen.',
  'DYN.selectedPaymentMethod.UNION_PAY': 'Sie haben ausgewählt, mit <b>Union Pay</b> zu bezahlen.',
  'DYN.selectedPaymentMethod.ZIMSWITCH': 'Sie haben ausgewählt, mit <b>Zimswitch</b> zu bezahlen.',
  'DYN.selectedPaymentMethod.PAYPAL': 'Sie haben ausgewählt, mit <b>PayPal</b> zu bezahlen.',
  'DYN.selectedPaymentMethod.DISCOVER': 'Sie haben ausgewählt, mit <b>Discover</b> zu bezahlen.',
  'ProvisionnalEntryPort': 'Gewünschter Registrierungspunkt',
  'payment_status.desc.offlineApplication': 'Diese Anwendung wird derzeit <b>OFFLINE</b> verarbeitet. Fahren Sie mit dem Vorgang fort, der nach Abschluss in die Synchronisationswarteschlange gesendet wird.',
  'warn.payment.offlineApplication.quit': 'Sie sind dabei, den Offline-Anwendungsprozess zu verlassen. Sind Sie sicher, dass Sie fortfahren möchten?<br><br><b>Alle Daten werden verloren gehen.</b>',
  'consumeMode.transit': 'Sie befinden sich derzeit im <b>Transit-Modus</b>, bei dem Anträge automatisch <b>gleichzeitig bearbeitet werden</b>. Dieser Modus wird für Reisende verwendet, die in Transit sind und keinen Aufenthalt im Land benötigen.',
  'no_apply.overstay': 'Keine Gebühr',
  'apply.overstay': 'Gebühr für die Beantragung',
  'paymentExtension.overstay': 'Diese Anwendung befindet sich derzeit in Überschreitung der Aufenthaltsdauer.<br><br><strong>Grundpreis für Verlängerung:</strong> {basePrice}<br><strong>Überschreitungsstrafe:</strong> {penalty}<br><strong>Gesamt mit Strafe:</strong> {totalPrice}<br><br>Sie können wählen, ob die Überschreitungsgebühr angewendet werden soll oder nicht.',
  'clear.storage.tooltip': 'Löschen Sie alle lokal gespeicherten Daten der Anwendung',
  'clear.storage': 'Speicherbereinigen',
  'ask.clear.storage': '<b>Diese Aktion führt eine vollständige Bereinigung der Website-Daten durch, ähnlich der Funktion "Website-Daten löschen" von Chrome.</b><br>Dies löscht: localStorage, sessionStorage, IndexedDB, Cache Storage, Service Workers, Cookies und andere Browser-Speicher. Alle Daten, die noch in der Warteschlange sind, werden in eine JSON-Datei heruntergeladen, bevor sie gelöscht werden.<br><br>Sind Sie sicher, dass Sie fortfahren möchten?',
  'download.logs.tooltip': 'Laden Sie die vollständigen Protokolle von Online- und Offline-Ausnahmeverhalten herunter. Diese Datei wird im JSON-Format heruntergeladen und dient hauptsächlich zum Debuggen.',
  'download.logs': 'Herunterladen von Protokollen',
  'scan.noEntryFound.wrongPassportType': 'Für diese Person wurde ein oder mehrere "Bereit zum Check-in"-Status gefunden, aber der Passtyp stimmt nicht mit dem gescannten Dokument überein.<br><b>Bitte erstellen Sie einen neuen Check-in für diese Person.</b>',
  'scan.noExitFound.wrongPassportType': 'Für diese Person wurde ein oder mehrere "Bereit zum Check-out"-Status gefunden, aber der Passtyp stimmt nicht mit dem gescannten Dokument überein.<br><b>Bitte erstellen Sie einen neuen Check-out für diese Person.</b>',
  'unlimited': 'Unbegrenzt',
  'help': 'Hilfe',
  'customerName': 'Kundenname',
  'printEvent.desc': 'Dieser Antrag wurde zusammen mit allen zugehörigen Dokumenten am {date} vom Benutzer gedruckt',
  'time.year': '{value} Jahr',
  'time.months': '{value} Monate',
  'time.month': '{value} Monat',
  'time.weeks': '{value} Wochen',
  'time.week': '{value} Woche',
  'time.days': '{value} Tage',
  'time.day': '{value} Tag',
  'print.alreadyPrinted': 'Die Dokumente dieses Antrags wurden zuletzt am {date} vom Benutzer {user} gedruckt. Möchten Sie sie erneut drucken?',
  'approval.daysGranted.limit': 'Die gewährten Tage dürfen die beantragten {days} Tage nicht überschreiten.',
  'paymentUntil.gracePeriod': 'Die folgende Anwendung befindet sich derzeit in der Nachsichtsfrist, die am <b>{date}</b> endet. <br><br> Sie können entscheiden, ob eine Gebühr für die Überziehung erhoben werden soll oder nicht.',
  'payment.consume.placeNotAllowed': 'Diese Anwendung kann an diesem Standort nicht bearbeitet werden. Der Reisende muss sich an einen der folgenden Standorte begeben: <br><b>{places}</b>',
  'tooltip.externalIndexedData': 'Mehrere Passports wurden für diese Person gefunden.',
  'visaDocumentsMaxTotalSize': 'Die Gesamtgröße der hochgeladenen Dokumente überschreitet die maximal zulässige Größe von {size} MB. Bitte reduzieren Sie die Größe der Dokumente und versuchen Sie es erneut.',
  'global.connection.timeout': 'Verbindung unterbrochen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
  'application.placeAllowed': '<b>STANDORTBESCHRÄNKUNG:</b> Dieses Dokument kann nur an den folgenden Standorten bearbeitet werden: <b>{places}</b>',
  'transactionReference.alt': 'Transaktionsreferenz',
  'paymentType.alt': 'Zahlungsart',
  'changeGender.ask': 'Das Geschlecht im Antrag muss entweder auf männlich oder weiblich geändert werden.',
  'print.askMultiple': 'Möchten Sie alle zugehörigen Dokumente in den Ausdruck aufnehmen?',
  'application.id': 'Antrags-ID',
  'printSticker': 'Visumaufkleber drucken',
  'correctionFields': 'Folgende Felder wurden korrigiert:',
  'corrected.desc': 'Dieser Antrag wurde am {date} vom Antragsteller korrigiert.',
  'recentlyCorrected': 'Korrigiert',
  'visaValidFrom': 'Eintritt gültig ab',
  'visaValidUntil': 'Eintritt gültig bis',
  'online': 'Online',
  'offline': 'Offline',
  'tooltip.delayed': 'Dieser Antrag ist verspätet.',
  'movement.tooltip': 'Details der Bewegungen des Antrags anzeigen.',
  'issuingOfficer.alt': 'Ausstellender Beamter',
  'placeOfIssue': 'Ausstellungsort',
  'tooltip.hasBeenCorrected': 'Dieser Antrag wurde vom Antragsteller korrigiert.',
  'tooltip.extendStay': 'Verlängern Sie den Aufenthalt des Antragstellers',
  'decisionLetter.title': 'Offizielles Visumsentscheidungs-Schreiben',
  'decisionLetter.approval.title': 'Visumantrag genehmigt',
  'decisionLetter.refusal.title': 'Visumantrag abgelehnt',
  'decisionLetter.applicationId': 'Antrags-ID',
  'decisionLetter.approvalDate': 'Genehmigungsdatum',
  'decisionLetter.refusalDate': 'Ablehnungsdatum',
  'decisionLetter.dear': 'Sehr geehrte',
  'decisionLetter.applicant': 'Antragstellerin oder Antragsteller',
  'decisionLetter.documentType.application': 'Visumantrag',
  'decisionLetter.documentType.extension': 'Aufenthaltsverlängerung',
  'decisionLetter.approval.body1': 'Ihr Visumantrag wurde genehmigt.',
  'decisionLetter.approval.body2': 'Bitte zeigen Sie den beigefuegten QR-Code bei Ihrer Ankunft am Grenzuebergang (PoE) vor.',
  'decisionLetter.refusal.body1': 'Ihr Visumantrag wurde nicht genehmigt.',
  'decisionLetter.refusal.body2': 'Falls erforderlich, koennen Sie gerne einen neuen Antrag einreichen und dabei alle Punkte beruecksichtigen, die zu der Ablehnung gefuehrt haben koennten.',
  'decisionLetter.signature': 'Im Namen des Generaldirektors der Einwanderungsbehoerde.',
  'printApprovalLetter': 'Genehmigungsschreiben drucken',
  'operation.REFUSEOUT': 'Check-out verweigert',
  'operation.REFUSEIN': 'Check-in verweigert',
  'error.closeApplication': 'Beim Schließen des Antrags ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'closeApplication': 'Als geschlossen markieren',
  'tooltip.closeApplication': 'Markieren Sie den Antrag als geschlossen. Diese Aktion ist irreversibel.',
  'transfert.viewOutOfState.desc': 'Sie sehen sich den Status des Antrags an. Bitte beachten Sie, dass Sie <b>WARNUNG</b>: Diese Anwendung könnte sich in einem falschen Zustand befinden. Bitte überprüfen Sie sorgfältig die vom Kunden bereitgestellten Dokumente, um den genauen Status dieser Anwendung zu bestätigen. Da Sie sich im <b>{consumeMode} Modus</b> befinden, haben Sie die Möglichkeit, die Verarbeitung als <b>{transfertMode}</b> zu erzwingen, auch wenn der aktuelle Status dies normalerweise nicht zulässt, falls Sie dies für notwendig erachten.',
  'understand': 'Ich verstehe',
  'request.viewOutOfState.button': 'Erzwingen "{consumeMode}"',
  'ExtraDocument1': 'Zusätzliches Dokument Nr. 1',
  'ExtraDocument2': 'Zusätzliches Dokument Nr. 2',
  'ExtraDocument3': 'Zusätzliches Dokument Nr. 3',
  'ExtraDocument4': 'Zusätzliches Dokument Nr. 4',
  'ExtraDocument5': 'Zusätzliches Dokument Nr. 5',
  'paperSize': 'Papierbreite',
  'change_lang': 'Sprache ändern',
  'queue.export.desc': 'Möchten Sie die aktuelle Warteschlange in eine JSON-Datei exportieren? <b>Ihre lokale Warteschlange wird nach dem Export gelöscht</b>. Möchten Sie wirklich fortfahren?',
  'queue.export': 'In JSON exportieren',
  'queue.import': 'Warteschlange aus JSON importieren',
  'nationality': 'Staatsangehörigkeit',
  'gender': 'Geschlecht',
  'HQReference': 'Hauptreferenz',
  'global.resetDefaults': 'Auf Standard zurücksetzen',
  'shortcuts.desc': 'Sie können unten Ihre eigenen Tastenkombinationen festlegen. Klicken Sie auf die Taste, für die Sie eine neue Tastenkombination festlegen möchten, und drücken Sie die gewünschte Taste auf Ihrer Tastatur.',
  'press.key': 'Drücken Sie eine beliebige Taste, um die Verknüpfung festzulegen...',
  'dashboard.keyboardShortcuts': 'Tastenkombinationen',
  'tooltip.changeShortcuts': 'Tastenkombinationen ändern',
  'global.changeShortcuts': 'Verknüpfungen ändern',
  'retake_picture': 'Bild erneut aufnehmen',
  'picture': 'Bild',
  'error.faceCheck': 'Beim Abgleich des Gesichts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'faceCheck.see_score': 'Gesichtserkennung',
  'recommendOrNot': 'Empfehlen oder nicht empfehlen',
  'recommended': 'Empfohlen',
  'not_recommended': 'Nicht empfohlen',
  'error.downgrade': 'Beim Herabstufen der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'done.downgrade': 'Die Anfrage wurde erfolgreich herabgestuft.',
  'request.downgrade': 'Herabstufen',
  'request.extendStay': 'Aufenthalt verlängern',
  'ResidencePermitNumber': 'Aufenthaltsgenehmigungsnummer',
  'error.payment.noInternalReference': 'Eine Hauptreferenz ist erforderlich, um diesen Antrag zu prüfen. Bitte warten Sie, bis die Referenz bereitgestellt wird.',
  'request.revision': 'Möchten Sie die Autoskip-Funktion aktivieren? Diese Funktion überspringt automatisch die geprüften Schritte, die keine Eingabe erfordern.',
  'notice.BORDER_PASS': 'Grenzpass',
  'form.borderPassNumber': 'Grenzpassnummer',
  'form.dateOfBirth': 'Geburtsdatum',
  'form.issueDate': 'Ausstellungsdatum',
  'form.authorizedCrossingPoints': 'Autorisierte Grenzübergänge',
  'form.issuedBy': 'Ausgestellt von',
  'form.externalCode': 'Externer Code (ICAO)',
  'err.invoke': 'Fehler',
  'ask.pendingRequest': 'Sie haben eine ausstehende Korrektur. Möchten Sie diese jetzt öffnen?',
  'entry.confirmation': 'Sind Sie sicher, dass alle bereitgestellten Informationen korrekt sind? Durch Klicken auf "Bestätigen" reichen Sie den Antrag ein.',
  'free': 'Kostenlos',
  'last_update': 'Letztes Update',
  'count': 'Anzahl',
  'tooltip.linkedExtensions': 'Dies ist eine Aufenthaltsverlängerung. Klicken Sie, um die Details anzuzeigen.',
  'extension': 'Verlängerung',
  'client.extended.badPaymentMetadata': 'Die Zahlungsmetadaten sind ungültig. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support, wenn das Problem weiterhin besteht.',
  'DaysRequested': 'Angeforderte Tage',
  'extensions.desc': 'Aufenthaltsverlängerung(en) zur Überprüfung ausstehend',
  'extend': 'Verlängern',
  'CheckboxVisaExtendFees': 'Ich bestätige, dass die bereitgestellten Informationen wahr und korrekt sind und ich den Gebühren, Bedingungen und der Datenschutzrichtlinie der Aufenthaltsverlängerung zustimme.',
  'AttestantDocument': 'Attestant-Dokument',
  'AffidavitCustody': 'Sorgerechtsbescheinigung',
  'CopyOfEntry': 'Einreisebeleg',
  'DepartureTicket': 'Abflugticket',
  'DYN.Self': 'Selbst',
  'DYN.Spouse/Dependent': 'Ehepartner/Angehöriger',
  'DYN.Employee/Employer': 'Mitarbeiter/Arbeitgeber',
  'DYN.Co-Director': 'Mitdirektor',
  'DYN.Lawyer': 'Rechtsanwalt',
  'VisaReference': 'Visareferenz',
  'ReasonForExtension': 'Grund für die Verlängerung',
  'AttestantID': 'Attestant-ID',
  'AttestantName': 'Name des Attestanten',
  'AttestantPhone': 'Telefonnummer des Attestanten',
  'AttestantEmail': 'E-Mail des Attestanten',
  'AttestantAddress': 'Adresse des Attestanten',
  'AttestantRelation': 'Beziehung des Attestanten',
  'start_extend': 'Aufenthalt verlängern',
  'visaExtend.title': 'Aufenthaltsverlängerung',
  'days': 'Tage',
  'day': 'Tag',
  'kiosk.standby.text1': 'Beginnen Sie, indem Sie Ihre Erklärung in nur wenigen Klicks auf diesem Tablet oder online ausfüllen.',
  'kiosk.standbyDesc.text1': 'Bitte beachten Sie vor dem Start folgende Informationen:',
  'kiosk.standbyDesc.li1': 'Sie füllen ein elektronisches Formular aus, das Ihre persönlichen Daten und Reisedetails erfasst.',
  'kiosk.standbyDesc.li2': 'Alle bereitgestellten Informationen müssen korrekt sein und mit Ihren Reisedokumenten (Reisepass, Visum usw.) übereinstimmen.',
  'kiosk.standbyDesc.li3': 'Nach dem Ausfüllen des Formulars können Sie direkt mit Ihrem Ausweisdokument zum Einwanderungsschalter gehen.',
  'kiosk.standbyDesc.li5': 'Wenn Sie Schwierigkeiten haben, können Sie sich jederzeit an das Personal am Grenzposten wenden.',
  'kiosk.standbyDesc.text2': 'Klicken Sie auf "Start", wenn Sie bereit sind, Ihre Einreiseerklärung auszufüllen.',
  'kiosk.success.title': 'Antrag erfolgreich eingereicht',
  'kiosk.success.text1': 'Sie können jetzt mit Ihren Reisedokumenten zum Einwanderungsschalter gehen. Ein Beamter wird die endgültigen Kontrollen durchführen und Ihre Einreise in das Land validieren.',
  'kiosk.success.text2': 'Wenn Sie Fragen oder Schwierigkeiten haben, wenden Sie sich bitte an das verfügbare Personal.',
  'confirm.revision': 'Überarbeitung bestätigen',
  'print.isDone': 'Wurde die Benachrichtigung erfolgreich gedruckt? Bitte stellen Sie sicher, dass Sie die gedruckte Benachrichtigung dem Antragsteller übergeben.',
  'form.hostPhone': 'Telefonnummer des Gastgebers',
  'transit': 'Transit',
  'conditionalEntry': 'Bedingte Einreise',
  'departure': 'Abreise',
  'form.paragraph': 'Absatz',
  'form.dateOfRefusal': 'Ablehnungsdatum',
  'form.purpose': 'Zweck',
  'form.host': 'Gastgeber',
  'form.officer': 'Beamter',
  'form.reportAt': 'Berichterstattung bei',
  'form.reportOn': 'Berichterstattung am',
  'form.reportInterval': 'Berichterstattungsintervall',
  'notice.desc.RESTRICTION': 'Die vorläufige Einschränkungsmitteilung informiert den Antragsteller über die Dokumente, die zur Vervollständigung des Verfahrens erforderlich sind. Sie können die fehlenden Dokumente auswählen, die der Antragsteller innerhalb eines bestimmten Zeitraums vorlegen muss.',
  'notice.REFUSAL': 'Einreiseverweigerungsmitteilung',
  'notice.desc.REFUSAL': 'Dem Antragsteller wird die Einreise in das Land verweigert.',
  'notice.desc.REPORTING': 'Die Besuchermitteilung ermöglicht dem Antragsteller die Einreise in das Land, kann jedoch einer weiteren Berichterstattung unterliegen. Sie können fehlende Dokumente auswählen, die der Antragsteller innerhalb eines bestimmten Zeitraums vorlegen muss.',
  'form.stationReference': 'Stationsreferenz',
  'form.fullNames': 'Vollständiger Name',
  'form.reportLocation': 'Berichterstattungsort',
  'form.daysUntilReport': 'Tage bis zur Berichterstattung',
  'form.otherMissingDocument': 'Weiteres fehlendes Dokument',
  'form.residentialAddress': 'Wohnadresse',
  'form.businessAddress': 'Geschäftsadresse',
  'form.hqReference': 'Hauptreferenz',
  'residentPermit': 'Aufenthaltserlaubnis',
  'notice.title': 'Verfügbare Mitteilungen zum Drucken',
  'notice.desc': 'Bitte wählen Sie eine Mitteilung aus der Liste unten aus. Nachdem Sie die erforderlichen Felder ausgefüllt haben, können Sie die Mitteilung für den Antragsteller drucken.',
  'notice.RESTRICTION': 'Vorläufige Einschränkungsmitteilung',
  'notice.REPORTING': 'Besuchsmitteilung',
  'notice.RESTRICTION.desc': 'Der Antragsteller muss die fehlenden Dokumente innerhalb eines bestimmten Zeitraums vorlegen.',
  'notice.REFUSAL.desc': 'Dem Antragsteller wird die Einreise in das Land verweigert.',
  'notice.REPORTING.desc': 'Dem Antragsteller wird die Einreise gestattet, er kann jedoch einer weiteren Berichterstattung unterliegen.',
  'passportType.kioskWarning': 'Die ausgewählte Staatsangehörigkeit unterliegt dem Regime der Kategorie C. Bitte gehen Sie sofort zu einem Einwanderungsbeamten.',
  'free.charge.total': 'Gesamtbetrag kostenlos',
  'err.entryPoints': 'Beim Laden der geplanten Einreisepunkte ist ein Fehler aufgetreten',
  'summary.your_meta': 'Ihre Daten (zum Öffnen anklicken)',
  'summary.payOnline': 'Ich zahle lieber jetzt online, als bei der Ankunft am Schalter des Beamten.',
  'summary.payOnline.desc': 'Durch Auswahl der untenstehenden Option gelangen Sie zur Zahlungsseite. Wenn Sie sich entscheiden, nicht online zu zahlen, zahlen Sie die Visagebühren am Schalter des Beamten bei der Ankunft für "Visa on arrival"-Visa-Typen.',
  'summary.meta': '\'s Daten (zum Öffnen anklicken)',
  'EmergencyLastName': 'Nachname des Notfallkontakts',
  'EmergencyFirstName': 'Vorname des Notfallkontakts',
  'EmergencyEmail': 'E-Mail des Notfallkontakts',
  'EmergencyPhone': 'Telefonnummer des Notfallkontakts',
  'person.name': 'Name der ausgewählten Person',
  'DYN.identity-card': 'Personalausweis',
  'DYN.resident-permit': 'Vorübergehende Aufenthaltserlaubnis',
  'DYN.identity-card.desc': 'Ein Personalausweis ist ein von der Regierung ausgestelltes Dokument zur Identifizierung im Inland.',
  'DYN.resident-permit.desc': 'Eine vorübergehende Aufenthaltserlaubnis ist ein offizielles Dokument, das von einer Regierung ausgestellt wird und es einem Ausländer erlaubt, für einen bestimmten Zeitraum in einem Land zu leben.',
  'NonOrdinaryPassMission': 'Grund für den offiziellen Besuch',
  'PreviousConvictionsHomeAsk': 'Wurden Sie oder einer Ihrer Angehörigen in Ihrem Heimatland wegen eines Verbrechens verurteilt?',
  'PlaceOfBirthCountry': 'Geburtsland',
  'PlaceOfBirthCity': 'Geburtsstadt',
  'OtherName': 'Andere(r) Name(n)',
  'travelName': 'Antragsreferenz',
  'plannedEntry': 'Geplanter Einreisehafen',
  'summary.title': 'Zusammenfassung',
  'urgent': 'Dringend',
  'visaType': 'Dokumententyp',
  'passportType': 'Art des Ausweises',
  'passportType.acknowledge': 'Durch die Auswahl dieses Pass-Typs bestätigen Sie, dass die Nichteinhaltung der Nutzungsbedingungen zur Verweigerung der Einreise führen kann.',
  'passportType.selectRefugeeNationality': 'Nationalität für Flüchtlingspass auswählen <br>',
  'form.travelName.already': '<b>Dieser Antrag wurde bereits mit der untenstehenden Antragsreferenz eingereicht. Wenn Sie die Referenz ändern möchten, starten Sie bitte einen neuen Antrag.</b>',
  'application.current_person': 'Sie bearbeiten derzeit den Antrag für',
  'DYN.USD': '$ USD',
  'DYN.EUR': '€ EUR',
  'DYN.ZWL': 'ZWL',
  'DYN.GBP': '£ GBP',
  'DYN.BWP': 'BWP',
  'DYN.KMF': '(KM)F',
  'participants.edit': 'Antragsteller bearbeiten',
  'request.existSaved': 'Ein gespeicherter Antrag wurde gefunden, möchten Sie dessen Daten laden? (Wenn Sie auf "Nein" klicken, wird der Antrag gelöscht und Sie starten einen neuen)',
  'participant.hasData': 'Sie haben bereits Daten für diesen Teilnehmer eingegeben. Wenn Sie fortfahren, gehen die Daten verloren. Sind Sie sicher, dass Sie fortfahren möchten?',
  'participant.selectAtLeastOne': 'Bitte wählen Sie mindestens einen Teilnehmer aus, um fortzufahren.',
  'participants.title': 'Antragsteller',
  'participants.desc': 'Bitte wählen Sie sich selbst und/oder die Person(en) aus, die Teil dieses Antrags sein werden.</br><b>Die Zahlung am Ende erfolgt für alle ausgewählten Personen.</b></br></br Sie können jederzeit eine Person hinzufügen/entfernen oder ihren Antrag bearbeiten, indem Sie auf den Namen klicken, der über dem Formular angezeigt wird.</br></br>{participantText}',
  'participant.ready': 'Wenn Sie bereit sind, klicken Sie auf "Fortfahren".',
  'participant.missing': 'Bitte erstellen Sie vor dem Fortfahren mindestens eine Person.',
  'travelName.title': 'Antragsreferenz',
  'form.travelName': 'Antragsreferenz',
  'form.travelName.desc': 'Die Antragsreferenz wird verwendet, um Ihren Antrag einfacher zu identifizieren.',
  'nationality.title': 'Staatsangehörigkeit',
  'nationality.desc': 'Bitte wählen Sie Ihr Land gemäß dem von Ihnen verwendeten Pass aus.',
  'passportType.title': 'Dokumententyp',
  'passportType.desc': 'Bitte wählen Sie die Art des Reisedokuments aus, das Sie für diesen Antrag verwenden.',
  'visaType.title': 'Visumtyp',
  'visaType.desc': 'Bitte wählen Sie den Visumtyp aus, für den Sie einen Antrag stellen möchten. Diese Liste variiert je nach Ihrer Staatsangehörigkeit und Art des Reisepasses.',
  'urgent.title': 'Normal/Dringend Visum',
  'urgent.desc': 'Wenn dieser Antrag <b>dringend</b> ist, wählen Sie diese Option. Die Bearbeitungszeit wird kürzer sein, aber eine <b>zusätzliche Gebühr</b> wird für diesen Service erhoben.</br></br>',
  'priority.normal': 'Normal',
  'priority.urgent': 'Dringend',
  'priority.normal.DYN.desc': 'Wird innerhalb von sieben (7) Arbeitstagen bearbeitet.',
  'priority.urgent.DYN.desc': 'Wird innerhalb von drei (3) Arbeitstagen bearbeitet.',
  'visa.paidOnArrival.title': 'Visum bei Ankunft bezahlt',
  'visa.paidOnArrival.desc': 'Ermöglicht es berechtigten Reisenden, ein Visum bei der Ankunft am Einreisehafen zu erhalten, was den Einreiseprozess für Kurzzeitbesuche vereinfacht.',
  'visa.paidOnline.title': 'Visum online bezahlt',
  'visa.paidOnline.desc': 'Ermöglicht eine oder mehrere Einreisen in das Land innerhalb eines bestimmten Zeitraums von einem (1) Monat, wobei für nachfolgende Einreisen ein neues Visum erforderlich ist.',
  'PassportType': 'Passart',
  'PassportCountry': 'Passausstellungsland',
  'form.passportCountry': 'Passausstellungsland',
  'DYN.ordinary': 'Gewöhnlicher Pass',
  'DYN.diplomatic': 'Diplomatenpass',
  'DYN.official': 'Offizieller Pass',
  'DYN.service': 'Dienstpass',
  'DYN.refugee': 'Flüchtlingspass oder Titre de Voyage',
  'DYN.ordinary.desc': 'Ein gewöhnlicher Pass ist die am häufigsten ausgestellte Art von Pass, der für allgemeine Reisezwecke an Bürger ausgegeben wird.',
  'DYN.diplomatic.desc': 'Ein Diplomatenpass wird Diplomaten und Konsuln für offizielle Reisen und Aufenthalte im Ausland ausgestellt.',
  'DYN.refugee.desc': 'Ein Flüchtlingspass wird von einem Land an Personen ausgestellt, die es als Flüchtlinge anerkennt, um ins Ausland zu reisen.',
  'DYN.official.desc': 'Ein offizieller Pass wird Regierungsangestellten für offizielle Reisen und Aufenthalte im Ausland ausgestellt.',
  'DYN.service.desc': 'Ein Dienstpass wird Regierungsangestellten für offizielle Reisen und Aufenthalte im Ausland ausgestellt.',
  'DYN.marine': 'Seemannspass',
  'DYN.marine.desc': 'Ein Seemannspass wird an Seeleute und Besatzungsmitglieder für Reisen und Aufenthalte im Ausland ausgestellt.',
  'DYN.laissez-passer': 'Laissez-passer',
  'DYN.laissez-passer.desc': 'Ein Laissez-passer ist ein von den Vereinten Nationen oder ihren Agenturen ausgestelltes Reisedokument für offizielle Reisen und Aufenthalte im Ausland.',
  'Urgent': 'Dies ist eine dringende Anfrage. Ich verstehe, dass die Bearbeitungszeit kürzer sein wird, die Gebühren jedoch höher.',
  'photo.passport.scanned': 'Reisepass jetzt gescannt',
  'review.nr.final': 'Endprüfung',
  'review.nr': 'Überprüfung Nr. ',
  'err.ArrivalDate.maxDateMilliTo': 'Es ist ein Zeitraum von mindestens sechs (6) Monaten zwischen dem Ablaufdatum Ihres Reisepasses und Ihrem Ankunftsdatum im Land erforderlich. Bitte erneuern Sie diesen Reisepass, bevor Sie ein Visum beantragen.',
  'err.DateOfExpiry.maxDateMilliTo': 'Ihr Reisepass läuft weniger als sechs (6) Monate vor Ihrem Ankunftsdatum im Land ab. Bitte erneuern Sie diesen Reisepass, bevor Sie ein Visum beantragen.',
  'place.update.error': 'Beim Aktualisieren des Ortes ist ein Fehler aufgetreten',
  'dashboard.kiosk.start': 'Prozess starten',
  'form.role.kiosk': 'Kiosk',
  'FundsAvailable': 'Betrag',
  'FundsAvailableCurrency': 'Währung',
  'emergency_contact_text': 'Bitte geben Sie im Notfall die Kontaktdaten einer Person an, die erreichbar ist.',
  'emergency_contact': 'Notfallkontakt / Nächster Angehöriger',
  'err.BirthDay.mustBeEqualOrBefore': 'Das Geburtsdatum muss gleich oder vor dem Ausstellungsdatum des Reisepasses liegen',
  'err.DateOfIssue.mustBeEqualOrAfter': 'Das Ausstellungsdatum muss gleich oder nach dem Geburtsdatum liegen',
  'internet.lost': 'Internetverbindung verloren.</br> Bitte überprüfen Sie Ihre Verbindung.',
  'err.DateOfExpiry.maxDateMilliFromToday': 'Ihr Reisepass läuft weniger als sechs (6) Monate ab heute ab. Bitte erneuern Sie diesen Reisepass, bevor Sie ein Visum beantragen.',
  'err.DepartureDate.maxDateMilliFrom': 'Das Abflugdatum liegt zu weit in der Zukunft im Vergleich zum Ankunftsdatum. Bitte beachten Sie die Zeitbegrenzung des Visums.',
  'requirements': 'Anforderungen',
  'err.file.size': 'Dateigröße ist zu groß. Maximale Größe ist: ',
  'revision.success': 'Ihre Aktualisierungsanfrage wurde erfolgreich eingereicht. Sie erhalten eine E-Mail mit dem QR-Code, sobald er genehmigt wurde.',
  'revision.free': 'Kostenlose Überarbeitung',
  'revision.start': 'Wir haben uns darum gekümmert, die Felder mit den Informationen auszufüllen, die Sie im ursprünglichen Antrag angegeben haben, mit Ausnahme der Felder, die Probleme verursachen. Bitte überprüfen Sie die Informationen und korrigieren Sie sie. Möchten Sie fortfahren?',
  'file_uploaded': 'Datei bereits hochgeladen und gespeichert',
  'refusal.desc2': 'Folgende Felder stellen ein Problem dar:',
  'start_correction': 'Korrektur beginnen',
  'payment.selectMode': 'Bitte wählen Sie die Felder aus, die ein Problem darstellen. Sie können mehrere Felder auswählen.',
  'suspendReason.desc': 'Bitte schreiben Sie eine kurze Beschreibung der Überarbeitungsanforderung. Diese Beschreibung wird dem Anforderer zusammen mit den ausgewählten Problemfeldern zugesendet.',
  'err.ArrivalDate.mustBeEqualOrBefore': 'Das Ankunftsdatum muss gleich oder vor dem Abreisedatum liegen',
  'err.DepartureDate.mustBeEqualOrAfter': 'Das Abreisedatum muss gleich oder nach dem Ankunftsdatum liegen',
  'qr.request_desc': 'Dieser QR-Code dient als digitaler Pass für die Visumbearbeitung. Die Regierung behält sich das Recht vor, die Einreise zum Zeitpunkt der Visumkontrolle zu genehmigen oder abzulehnen.',
  'request_state.PENDING': 'Ausstehend',
  'document.Screening': 'Überprüfung',
  'err.SpouseBirthDay.max': 'Ungültiges Geburtsdatum des Ehepartners',
  'err.ArrivalDate.min': 'Ungültiges Ankunftsdatum',
  'err.DepartureDate.min': 'Ungültiges Abreisedatum',
  'err.DateOfIssue.max': 'Ungültiges Ausstellungsdatum',
  'err.BirthDay.max': 'Ungültiges Geburtsdatum',
  'err.dependants_date_of_birth.max': 'Ungültiges Geburtsdatum des Angehörigen',
  'err.DateOfExpiry.min': 'Ungültiges Ablaufdatum',
  'dependants': 'Angehörige',
  'male': 'Männlich',
  'female': 'Weiblich',
  'other': 'Anderes',
  'single': 'Ledig',
  'married': 'Verheiratet',
  'separated': 'Getrennt',
  'divorced': 'Geschieden',
  'widowed': 'Verwitwet',
  'select_reason_first': 'Bitte wählen Sie auf der vorherigen Seite den Besuchsgrund aus, um die Liste der erforderlichen Dokumente zu sehen.',
  'visaIntro.title': 'Antrag',
  'remove': 'Entfernen',
  'dependant_add': 'Angehörigen hinzufügen',
  'dependant': 'Angehöriger',
  'upload_file': 'Datei hochladen (< {size})',
  'PassportPhoto': 'Aktuelles Passfoto',
  'PassportScan': 'Biometrische Passdatenseite',
  'EventInvitationLetter': 'Einladungsschreiben für die Veranstaltung',
  'ProofOfResidenceHost': 'Wohnsitz/Buchungsnachweis des Gastgebers (unterschrieben)',
  'AddressAtDestination': 'Adresse am Zielort',
  'HostInvitationLetter': 'Einladungsschreiben des Gastgebers',
  'ProofOfResidence': 'Wohnsitznachweis',
  'ApplicationLetter': 'Antragsschreiben',
  'ResidentialStatusOfHost': 'Wohnstatus des Gastgebers',
  'ReasonOfVisitProof': 'Nachweis des Besuchsgrundes',
  'BusinessLetter': 'Geschäftsbrief/Persönliches Schreiben',
  'BusinessProfile': 'Geschäftsprofil',
  'InvitationLetterAndBusinessProfile': 'Einladungsschreiben und Gastgeberunterlagen (unterschrieben)',
  'InvitationLetter': 'Einladungsschreiben',
  'LetterOfAcceptanceFromSchool': 'Bestätigungsschreiben',
  'DYN.male': 'Männlich',
  'DYN.female': 'Weiblich',
  'DYN.other': 'Anderes',
  'DYN.single': 'Ledig',
  'DYN.married': 'Verheiratet',
  'DYN.separated': 'Getrennt',
  'DYN.divorced': 'Geschieden',
  'DYN.widowed': 'Verwitwet',
  'DYN.married_according_to_custom': 'Nach den Bräuchen verheiratet',
  'DYN.religiously_married': 'Religiös verheiratet',
  'passport.valid': 'Das gescannte Dokument scheint weder manipuliert noch widerrufen worden zu sein und ist vom ausstellenden Land unterzeichnet.',
  'travel_information_title': 'Vorsicht',
  'visaPrice.desc': 'Sie müssen diese Zahlung am Ende des Antrags mit Visa oder MasterCard vornehmen. Diese Zahlung ist nicht erstattungsfähig.',
  'visaPrice': 'Visumspreis',
  'required': 'Erforderlich',
  'DYN.holiday_visa': 'Urlaub',
  'DYN.live_here': 'Langzeitaufenthalt',
  'DYN.business_visa': 'Geschäftlich',
  'DYN.conferencing_visa': 'Konferenz',
  'DYN.transit_visa': 'Transit',
  'DYN.student_visa': 'Studium',
  'DYN.sports_visa': 'Sport',
  'DYN.arts_visa': 'Kunst',
  'DYN.other_visa': 'Andere',
  'DYN.event_visa': 'Veranstaltung',
  'document': 'Dokument',
  'documents_attached': 'Anzuhängende Dokumente',
  'Dependants': 'Angehörige',
  'dependants_name': 'Name',
  'dependants_passport_number': 'Reisepassnummer',
  'dependants_date_of_birth': 'Geburtsdatum',
  'dependants_place_of_birth': 'Geburtsort',
  'Spouse': 'Ehepartner',
  'SpouseFullName': 'Name des Ehepartners',
  'SpousePassportNumber': 'Reisepassnummer des Ehepartners',
  'SpouseBirthDay': 'Geburtsdatum des Ehepartners',
  'SpousePlaceOfBirth': 'Geburtsort des Ehepartners',
  'ArrivalDate': 'Voraussichtliches Ankunftsdatum',
  'DepartureDate': 'Voraussichtliches Abreisedatum',
  'ReferencePreviousVisa': 'Referenz des vorherigen Visums',
  'PreviousConvictionsHome': 'Art der Verurteilung(en) im Heimatland',
  'travel_information': 'Reiseinformationen',
  'DateOfIssue': 'Ausstellungsdatum',
  'DateOfExpiry': 'Ablaufdatum',
  'PlaceofIssue': 'Ausstellungsort',
  'Email': 'E-Mail',
  'Phone': 'Telefonnummer',
  'form.selectCountry': 'Land auswählen',
  'HomeAddress': 'Aktuelle Wohnadresse',
  'HostName': 'Name des Gastgebers',
  'err.InvitingCompanyName.required': 'Name des einladenden Unternehmens ist erforderlich',
  'InvitingCompanyName': 'Name des einladenden Unternehmens',
  'form.seniority': 'Dienstgrad',
  'LastName': 'Nachname',
  'FirstName': 'Vorname(n)',
  'BirthDay': 'Geburtsdatum (Genau wie im Reisepass)',
  'PlaceOfBirth': 'Geburtsort',
  'Gender': 'Geschlecht',
  'MaritalStatus': 'Familienstand',
  'CheckboxVisaFees': 'Ich bestätige, dass die bereitgestellten Informationen wahrheitsgemäß und korrekt sind und ich den Visagebühren, den Bedingungen und der Datenschutzrichtlinie zustimme.',
  'PassportNumber': 'Reisepassnummer',
  'Nationality': 'Staatsangehörigkeit',
  'err.nationality.required': 'Die Staatsangehörigkeit ist erforderlich.',
  'PurposeOfVisit': 'Besuchsgrund',
  'VisaType': 'Visumtyp',
  'visitor_details': 'Angaben zum Antragsteller',
  'personal_details': 'Persönliche Angaben',
  'contact_details': 'Kontaktangaben',
  'miscellaneous_details': 'Reisedetails',
  'spouse_details': 'Angaben zum Ehepartner',
  'payment': 'Zahlung',
  'global.scan_qr': 'QR-Code überprüfen',
  'qr.nosuch': 'Laden... QR-Code im System noch nicht gefunden. Überprüfen Sie die Internetverbindung.',
  'qr.faked': 'Serverantwort ist, dass der QR-Code nicht existiert. Es handelt sich wahrscheinlich um eine Fälschung!',
  'qr.quicklook': 'Wichtige Informationen',
  'global.toPayments.DYN.': 'Anträge anzeigen',
  'payment.duplicate.open': 'Neue Zahlung öffnen?',
  'form.importantRead': 'WICHTIG - SORGFÄLTIG LESEN',
  'form.completeInEnglish': 'Deutlich auf Englisch ausfüllen.',
  'form.selectApplicableFields': 'Wählen Sie alle zutreffenden Felder unten aus.',
  'ONE_DAY': '1 Tag',
  'THREE_DAYS': '3 Tage',
  'ONE_WEEK': '1 Woche',
  'TWO_WEEKS': '2 Wochen',
  'ONE_MONTH': '1 Monat',
  'TWO_MONTHS': '2 Monate',
  'SIX_MONTHS': '6 Monate',
  'ONE_YEAR': '1 Jahr',
  'place_created.desc': 'Der neue Ort wurde erstellt und ist nun verwendbar.',
  'payment_status.DYN.NONE': '-- Kein Filter --',
  'dropdown.state': 'Status',
  'payment.qrList.title': 'Liste der QR-Zahlungen',
  'see.qr_list': 'Liste der QR-Codes anzeigen',
  'form.role.partner_registrer': 'Partner registrieren',
  'form.reason': 'Grund',
  'global.reject': 'Ablehnen',
  'payment.validate_desc': 'Sind Sie sicher, dass Sie diese Zahlung validieren möchten?',
  'payment.reject_desc': 'Sind Sie sicher, dass Sie diese Zahlung ablehnen möchten? Vergessen Sie nicht, einen Grund anzugeben.',
  'qr.title': 'QR-Code',
  'dashboard': 'Dashboard',
  'dashboard.people.DYN.': 'Gespeicherte Personen',
  'dashboard.my_account': 'Mein Konto',
  'form.id': 'ID',
  'payments.scan': 'QR scannen',
  'print.qr.desc': 'Dies ist ein einzigartiger und gesicherter QR-Code, der nur so oft verwendet werden kann, wie angegeben. Verändern Sie ihn nicht, damit er gültig bleibt.',
  'print.qr.title': 'QR-Code',
  'print.informations': 'Informationen',
  'print.notice.folding': 'Faltanleitung',
  'print.notice.desc2': 'Bei Fragen zu diesem Dokument wenden Sie sich bitte telefonisch oder per E-Mail an den Support.',
  'print.notice.desc1': 'Bewahren Sie dieses Dokument vor Wasser oder Flammen auf.',
  'print.notice.title': 'Hinweis',
  'client.extended.openSuchPayment': 'Es ist bereits eine Zahlung unter diesem Benutzer aktiv',
  'form.externalId': 'Zahlungsreferenz',
  'form.userExternalId': 'Externe ID',
  'global.confirm': 'Bestätigen',
  'global.submit': 'Einreichen',
  'global.back': 'Zurück',
  'global.close': 'Schließen',
  'global.contact_support': 'Support kontaktieren',
  'global.previous': 'Vorherige',
  'global.next': 'Nächste',
  'global.accept': 'Akzeptieren',
  'global.support': 'Support',
  'global.consume': 'Verbrauchen',
  'global.validate': 'Validieren',
  'global.reset': 'Zurücksetzen',
  'global.delete': 'Löschen',
  'global.update': 'Aktualisieren',
  'global.download': 'Herunterladen',
  'global.print': 'Drucken',
  'global.print_c7': 'Ticket drucken',
  'global.checkIn': 'Einchecken',
  'choose-lang.title': 'Spracheinstellung',
  'choose-lang.desc': 'Bitte wählen Sie die Sprache, die für diesen Antrag verwendet werden soll.',
  'global.personalNum': 'Personal-Nr.',
  'global.passportNum': 'Passnummer',
  'global.add': 'Hinzufügen',
  'global.block': 'Blockieren',
  'global.blocked': 'Blockiert',
  'global.unblock': 'Entsperren',
  'global.daily_otp': 'Täglicher Code',
  'global.refresh': 'Aktualisieren',
  'global.connect': 'Verbinden',
  'global.disconnect': 'Trennen',
  'form.email': 'E-Mail',
  'form.name': 'Name',
  'form.firstName': 'Vorname(n)',
  'form.lastName': 'Nachname',
  'form.password': 'Passwort',
  'form.password2': 'Passwort erneut eingeben',
  'form.linkType': 'Welche Verbindung hat diese Person zu Ihnen?',
  'form.userId': 'Benutzer-ID',
  'form.parentId': 'Eltern-ID',
  'form.amount': 'Betrag',
  'form.currency': 'Währung',
  'form.buyingOption': 'Gekauftes Dokument',
  'form.place': 'Ort',
  'form.role': 'Rolle',
  'form.connectUAPattern': 'Benutzeragentenmuster',
  'form.connectIPRange': 'IP-Bereich',
  'form.state': 'Zustand',
  'form.created_date': 'Erstellungsdatum',
  'form.created_place': 'Erstellungsort',
  'form.consumed_place': 'Verbrauchsort',
  'form.email_code': 'Code aus der E-Mail',
  'form.phone': 'Telefonnummer',
  'form.worker': 'Mitarbeiter-ID',
  'form.password_old': 'Aktuelles Passwort',
  'form.password_new': 'Neues Passwort',
  'form.idCard': 'Personalausweis-Nr.',
  'form.type.CASH': 'Bar',
  'form.type.CARD': 'Karte',
  'form.role.customer': 'Kunde',
  'form.role.worker': 'Mitarbeiter',
  'yes': 'Ja',
  'no': 'Nein',
  'form.borderPass': 'Grenzpass ausstellen',
  'form.role.orbis_consumer': 'Orbis-Kunde',
  'form.role.admin': 'Administrator',
  'form.perm2.DYN.': 'Antrag verwenden',
  'form.perm3.DYN.': 'Antrag überprüfen',
  'form.perm4.DYN.': 'Orte, Benutzer und Visumanträge erstellen/verwalten',
  'form.perm2.DYN.pass': 'QR-Code verwenden',
  'form.perm2.DYN.zwevisa': 'Visumantrag verwenden',
  'form.perm3.DYN.pass': 'QR-Code duplizieren/erstatten & Z von Unterplätzen',
  'form.perm3.DYN.zwevisa': 'Visumantrag überprüfen',
  'form.perm4.DYN.pass': 'Benutzer erstellen/verwalten & Unterplätze erstellen',
  'form.perm4.DYN.zwevisa': 'Orte, Benutzer und Visumanträge erstellen/verwalten',
  'client.extended.clientNotAllowed': 'Ihr Konto ist an diesem Ort derzeit nicht zulässig. Bitte überprüfen Sie Ihre Verbindungseinstellungen.',
  'err.submit': 'Fehler beim Einreichen des Formulars',
  'err.place.required': 'Ort ist erforderlich',
  'err.noSmsPerm': 'SMS-Recht wurde nicht gewährt',
  'err.noSmsReceive': 'SMS-Lektüre kann nicht gebunden werden',
  'helps.showProceed': 'Vorgang anzeigen',
  'helps.showScan': 'Dokument scannen',
  'payment_status.DYN.undefined': 'Aktueller Zustand - keine Operation',
  'client.extended.missingResourceLogin': 'Verbindung konnte nicht hergestellt werden, falsche Anmeldedaten',
  'client.extended.linkedAccountExists': 'Ein Konto mit dieser E-Mail existiert bereits',
  'client.extended.attachedPayments': 'Sie können diese Person nicht ändern, sie hat bereits einen verknüpften Antrag.',
  'client.extended.badPayload': 'Fehlerhafte Informationen in der Anfrage',
  'client.extended.placeNotAllowed': 'Ort nicht erlaubt',
  'client.extended.locked': 'Konto ist gesperrt',
  'client.extended.clientBadOtp': 'Falscher täglicher Code',
  'client.extended.confirmationRequired': 'Bestätigung erforderlich',
  'confirmationRequired.email': 'Ein Bestätigungslink wurde an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihren Posteingang und bestätigen Sie vor der Anmeldung.',
  'confirmationRequired.sms': 'Ein Bestätigungslink wurde per SMS gesendet. Bitte überprüfen Sie Ihre Nachrichten und bestätigen Sie vor der Anmeldung.',
  'client.extended.badPaymentConfirmation': 'Zahlung kann nicht durchgeführt werden: eine der Prüfungen ist fehlgeschlagen',
  'time': 'Zeit',
  'place': 'Ort',
  'home.first': 'Ihr Konto wurde jetzt bestätigt und Sie können sich anmelden.',
  'payOnline': 'Online bezahlen',
  'login.sign_in': 'Anmelden',
  'photo.unavailable': 'Bild nicht verfügbar',
  'global.entry': 'Einreise',
  'global.exit': 'Ausreise',
  'menu.users': 'Benutzer',
  'menu.places': 'Orte',
  'create_user.title': 'Benutzer erstellen',
  'create_payment.title': 'Zahlung erstellen',
  'create_place.title': 'Ort erstellen',
  'users.title': 'Benutzerdatenbank',
  'payments.title': 'Zahlungsdatenbank',
  'payments.download_csv': 'CSV herunterladen',
  'create_card_payment.title': 'Online-Zahlung',
  'places.title': 'Liste der Orte',
  'forgot_password.title': 'Passwort zurücksetzen',
  'welcome.title_1.DYN.': 'Willkommen bei {appName}',
  'welcome.text_1.DYN.': 'Willkommen auf dem offiziellen Portal von {appName}.<br>Dieser Online-Service macht es einfach und sicher, Ihre offiziellen Dokumente zu erhalten.',
  'welcome.text_1.1.DYN.': 'Bereit zu erfahren, wie es funktioniert? Legen wir los!',
  'welcome.title_2.DYN.': 'Was ist {appName}?',
  'welcome.text_2.DYN.': '{appName} ist eine sichere digitale Plattform, mit der Sie Ihre offiziellen Dokumente online beantragen können: Personalausweis, Reisepass, Aufenthaltserlaubnis und mehr.',
  'welcome.text_2.1.DYN.': 'Beantragen Sie Ihre Dokumente von überall und erhalten Sie diese per E-Mail, mit einem einzigartigen QR-Code, der ihre Echtheit garantiert.',
  'welcome.title_3.DYN.': 'Als Mitarbeiter',
  'welcome.text_3.DYN.': 'Mit {appName} können Sie Anträge offline verwalten. Wir vertrauen auf unsere sichere und zuverlässige Art der QR-Code-Generierung.',
  'welcome.text_3.1.DYN.': 'Sie können auch die Nutzer und Standorte Ihrer Organisation verwalten.',
  'welcome.text_4.DYN.': 'Sie können Anträge sogar offline verwalten. Wir vertrauen auf unsere sichere und zuverlässige Art der QR-Code-Generierung.',
  'welcome.text_4.1.DYN.': 'Sobald Sie wieder online sind, wird alles automatisch synchronisiert.',
  'welcome.title_5.DYN.': 'Starten Sie Ihren Antrag',
  'welcome.text_5.DYN.': 'Auf den folgenden Seiten können Sie Ihre offiziellen Dokumente online mit nur wenigen Klicks beantragen.<br><br>Nach Genehmigung Ihres Antrags erhalten Sie Ihre Dokumente per E-Mail sowie einen sicheren QR-Code, der alle notwendigen Informationen für eine schnelle und zuverlässige Überprüfung enthält.',
  'payment_status.DYN.PROPOSED': 'Zahlung ausstehend',
  'payment_status.DYN.PAID': 'Bereit zum Einchecken',
  'payment_status.DYN.PAID_NOT_CONFIRMED': 'Warten auf Überprüfung',
  'payment_status.DYN.USED': 'Ausgecheckt',
  'payment_status.DYN.DUPLICATED': 'Dupliziert',
  'payment_status.DYN.REFUNDED': 'Erstattet',
  'payment_status.DYN.EXPIRED': 'Abgelehnt',
  'payment_status.DYN.PENDING': 'Korrektur ausstehend',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED': 'Später zahlen - Nicht bestätigt',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED.FREE': 'Kostenlos - Nicht bestätigt',
  'payment_status.DYN.DELAY_PAY': 'Bereit zur Zahlung bei Ankunft',
  'payments.validate': 'Bestätigen',
  'documentContinue.title': 'Einkauf fortsetzen',
  'bt.available_devices': 'Verfügbare Bluetooth-Geräte',
  'bt.no_available_devices': 'Keine verfügbaren Bluetooth-Geräte erkannt',
  'emailSend.title': 'E-Mail-Verifizierung',
  'emailSend.description': 'Um Ihr Konto zu bestätigen, müssen Sie auf den Link klicken, der sich in einer Bestätigungs-E-Mail befindet, die innerhalb von 24 Stunden an Ihre E-Mail-Adresse gesendet wurde.',
  'emailValid.title': 'Konto bestätigt',
  'emailValid.description': 'Ihr {appName}-Konto wurde erfolgreich bestätigt. Sie können nun auf Ihren persönlichen Bereich zugreifen, indem Sie sich mit Ihren Anmeldedaten anmelden.',
  'documentManagement.title': 'Antrag',
  'preenroll.title': 'Voranmeldung',
  'passportEmbassy.title': 'Botschaftsdokument',
  'zwevisa.title': 'Visum',
  'passwordSend.title': 'Bestätigung gesendet',
  'passwordSend.description': 'Sie haben eine Bestätigungs-E-Mail mit einem Link zum Zurücksetzen Ihres Passworts erhalten. Sie haben 24 Stunden Zeit, darauf zu klicken.',
  'forgotPassword.title': 'Passwort vergessen',
  'forgotPassword.description': 'Um Ihr Passwort zurückzusetzen, geben Sie unten die E-Mail-Adresse Ihres Kontos ein.',
  'forgotPassword.description.electron': 'Um Ihr Passwort zurückzusetzen, geben Sie unten die E-Mail-Adresse Ihres Kontos ein. Wenn Sie versuchen, ein Passwort für ein <b>Active Directory</b>-Konto wiederherzustellen, wenden Sie sich bitte an den Support.',
  'passwordNew.title': 'Neues Passwort',
  'modifiedPassword.title': 'Passwort geändert',
  'modifiedPassword.description': 'Das Passwort wurde geändert. Bitte melden Sie sich erneut an.',
  'people.title.DYN.': 'Gespeicherte Personen',
  'people.addPerson.DYN.': 'Neue Person erstellen',
  'meansPayment.title': 'Zahlungsmethoden',
  'onlinePayment.title': 'PayPal-Zahlung',
  'onlinePayment.pay': 'Bezahlen',
  'qrPayment.title': 'Zahlung per QR-Code',
  'form.expireDate': 'Ablaufdatum',
  'successPayment.title': 'Bestellbestätigung',
  'trackingControl.title.DYN.': 'Diesen Antrag verfolgen',
  'modifyData': 'Daten ändern',
  'stopModifyData': 'Datenänderung stoppen',
  'askVisa': 'Ein Visum anfordern',
  'peopleNew.title.DYN.': 'Neue Person',
  'peopleFound.title.DYN.': 'Person gefunden',
  'peopleFound.description.DYN.': 'Die Person, die den eingegebenen Informationen entspricht, wurde der Liste der gespeicherten Personen hinzugefügt.',
  'payment.commandHistory': 'Zahlungshistorie',
  'menu.placesPerm': 'Orte und Berechtigungen',
  'block.message': 'Möchten Sie diesen Benutzer blockieren?',
  'menu.addPlace': 'Einen Ort hinzufügen',
  'label.numberAccount': 'Konto-Nr.',
  'place.sheet.open': 'Blatt des Ortes öffnen',
  'place.delete': 'Verknüpfung mit diesem Ort löschen',
  'place.update.success': 'Der Ort wurde erfolgreich aktualisiert.',
  'place.new': 'Neuer Ort',
  'place.create': 'Ort erstellen',
  'place.add.ask': 'Möchten Sie diesen Ort mit diesem Benutzer verknüpfen?',
  'place.delete.link': 'Verknüpfung mit diesem Ort löschen',
  'place.delete.link.ask': 'Sind Sie sicher, dass Sie die Verknüpfung mit diesem Ort aufheben möchten?',
  'place.delete.link.done': 'Sie haben die Verknüpfung mit dem Ort erfolgreich aufgehoben.',
  'user.new': 'Neuer Benutzer',
  'user.create': 'Benutzer erstellen',
  'user.created': 'Das Erstellen des neuen Benutzers war erfolgreich. Dieses Konto kann nun verwendet werden.',
  'user.sheet.open': 'Blatt des Benutzers öffnen',
  'payment.sheet.open': 'Blatt der Zahlung öffnen',
  'err.createplace': 'Erstellen nicht möglich. ID existiert bereits.',
  'place.parent': 'Übergeordneter Ort',
  'dropdown.qr': 'QR-Code scannen',
  'dropdown.pass': 'Dokument scannen',
  'err.noReader': 'Der Leser ist nicht verbunden. Bitte schließen Sie den Leser an, um fortzufahren.',
  'err.noCard': 'Kein gültiges biometrisches Dokument im Leser erkannt. Dies kann an der Verwendung eines nicht biometrischen Dokuments, der Vorlage einer unbefugten Kopie oder Fälschung oder einer Fehlfunktion der Antenne liegen.',
  'err.noConnect': 'Dieses Dokument entspricht nicht den ICAO-Standardprotokollen. Dies kann auf die Verwendung eines nicht biometrischen Dokuments, die Vorlage einer unbefugten Kopie oder Fälschung oder eine Fehlfunktion der Antenne zurückzuführen sein.',
  'err.noBAC': 'Sicherer Kanal zum Dokument konnte nicht hergestellt werden, ist es echt? Überprüfen Sie dieses Dokument gründlich manuell und befragen Sie den Inhaber.',
  'err.alteredDoc': 'Dokumentfelder konnten nicht gelesen werden, ist es echt? Überprüfen Sie dieses Dokument gründlich manuell und befragen Sie den Inhaber.',
  'err.revokedDocSigner': 'Der Unterzeichner dieses Dokuments wurde von der ausstellenden Behörde widerrufen. Möglicherweise wurde dieses Dokument betrügerisch unterzeichnet. Befragen Sie den Inhaber gründlich dazu.',
  'err.unverifiedDoc': 'Dokumentgültigkeit konnte nicht überprüft werden, Fehler im Authentifizierungsprotokoll, dies könnte auf ein außerhalb des Landes nach der ICAO-Masterliste ausgestelltes Dokument, ein gefälschtes Dokument oder eine Fehlfunktion der Antenne hindeuten.',
  'err.noPassiveAuthentication': 'Dokumentgültigkeit konnte nicht überprüft werden, Fehler im Authentifizierungsprotokoll, gefälschtes Dokument oder Fehlfunktion der Antenne.',
  'err.noResult': 'Keine Datei gefunden',
  'payment.new.DYN.': 'Neue Ausreise ohne Visum',
  'payment.created.register': 'Registrierte Zahlung',
  'payment.created': 'Ihre Zahlung wurde gespeichert und ist nun in der Liste der Zahlungen sichtbar.',
  'payment.created.qr': 'Eine E-Mail mit dem generierten QR-Code wurde an die angegebene E-Mail-Adresse gesendet.',
  'idcard.number': 'Personalausweisnummer',
  'form.userCreator': 'Erstellt durch den Benutzer',
  'form.userRefund': 'Erstattet durch den Benutzer',
  'form.userConsumed': 'Verbraucht durch den Benutzer',
  'PRICEUP': 'Preis 0-9',
  'PRICEDOWN': 'Preis 9-0',
  'RECENT': 'Neueste',
  'LATEST': 'Älteste',
  'STATUSUP': 'Status a-z',
  'STATUSDOWN': 'Status z-a',
  'payment.success': 'Ihre Zahlung wurde registriert',
  'payment.consume.ask.DYN.': 'Möchten Sie diesen Antrag wirklich ein-/auschecken?',
  'checkinOut.refuse': 'Möchten Sie diesen Antrag wirklich ablehnen?',
  'payment.duplicate': 'Duplizieren',
  'payment.duplicate.ask': 'Möchten Sie diese Zahlung wirklich duplizieren?',
  'payment.duplicate.done': 'Ihre Zahlung wurde erfolgreich dupliziert',
  'tooltip.duplicatePayment': 'Diese Zahlung duplizieren, um eine Wiederverwendung zu ermöglichen',
  'payment.refund.ask': 'Möchten Sie diese Zahlung wirklich erstatten?',
  'payment.refund.done': 'Ihre Zahlung wurde erfolgreich erstattet',
  'payment.refund.exist': 'Diese Zahlung wurde bereits erstattet',
  'payment.paid.error': 'Ihre Zahlung muss den Status "Abgeschlossen" haben',
  'block.done': 'Das Konto wurde gesperrt',
  'block.unblock': 'Das Konto wurde entsperrt',
  'place-add.add': 'Ort hinzufügen',
  'permission.title': 'Erforderliche Berechtigung: Kamera',
  'qr.see': 'Den QR-Code anzeigen',
  'qr.desc.DYN.': 'Hier ist der QR-Code für den Antrag. Er wird während eines Ausdrucks erscheinen und an die bei der Registrierung eingegebene E-Mail-Adresse gesendet.',
  'dashboard.place.verif': 'Wenn Sie keinen Ort eingegeben haben, tun Sie dies bitte',
  'block.yourself': 'Sie können sich nicht selbst blockieren',
  'lastPlace.delete': 'Der letzte Ort in diesem Konto wird gelöscht. Dies macht das Konto unbrauchbar. Fortfahren?',
  'place.add.done': 'Dieser Ort wurde erfolgreich zu diesem Benutzer hinzugefügt',
  'no.connection': 'Um auf diese Seite zuzugreifen, müssen Sie mit dem Internet verbunden sein. Bitte melden Sie sich erneut an',
  'place.delete.success': 'Dieser Ort wurde gelöscht.',
  'wrong.current': 'Sie haben ein falsches aktuelles Passwort eingegeben',
  'no.place': 'Kein Ort für dieses Konto.',
  'email.error': 'Ähnliche E-Mail existiert bereits',
  'email.notexist': 'E-Mail existiert nicht',
  'one.payment': 'Sie müssen mindestens eine oder mehrere Zahlungen erstellt und/oder gefiltert haben.',
  'err.client.extended.uuidUsed': 'Diese Zahlung wurde bereits verwendet',
  'client.extended.uuidUsed': 'Diese Zahlung wurde bereits verwendet',
  'no.activecamera': 'Keine aktive Kamera gefunden',
  'no.accessPermission': 'Dieses Konto hat keine Zugriffsberechtigung',
  'print.name': 'Drucker',
  'print.success': 'Ihr Ticket wurde gedruckt',
  'print.need': 'Sie müssen zuerst eine Verbindung zu einem Drucker herstellen, um drucken zu können',
  'printer.connect': 'Sie sind jetzt mit dem Drucker verbunden:',
  'permission.desc': 'Der Dienst, den Sie verwenden möchten, erfordert die Erlaubnis zur Nutzung der Kamera Ihres Geräts',
  'createPeople.ask.DYN.': 'Möchten Sie diese neue Person wirklich erstellen?',
  'createPeopleDuplicate.ask.DYN.': 'Es scheint, dass eine Person mit demselben Namen bereits in Ihrer Liste der registrierten Personen vorhanden ist. Möchten Sie diese Person trotzdem erstellen?',
  'deletePerson.DYN.': 'Diese Person löschen',
  'deletePerson.ask.DYN.': 'Sind Sie sicher, dass Sie diese Person löschen möchten?',
  'deletePerson.valid.DYN.': 'Die Person wurde gelöscht',
  'personModification.ask.DYN.': 'Sind Sie sicher, dass Sie die Daten dieser Person ändern möchten?',
  'personModification.valid.DYN.': 'Die Daten der Person wurden geändert',
  'noPayment': 'Keine Zahlung',
  'selfie.desc': 'Ein Foto ist für die Dokumentanforderung erforderlich, stellen Sie sicher, dass Sie bei guter Beleuchtung sind und Ihr Telefon ruhig halten, um ein unscharfes Bild zu vermeiden. Stellen Sie außerdem sicher, dass alle Details Ihres Gesichts auf dem Foto gut sichtbar sind.',
  'ZWEVISA.title': 'Visum',
  'EMBASSYPASS.title': 'Botschaftspass',
  'PREENROLL.title': 'Voranmeldung',
  'DYN.NOK': 'Anfrage abgelehnt',
  'WIP': 'In Arbeit',
  'menu.requests.DYN.': 'Anträge',
  'menu.createRequests.DYN.': 'Neuer Antrag',
  'request_state.SUBMITTED': 'Eingereicht',
  'request_state.CONFIRMED': 'Bestätigt',
  'request_state.TREATED': 'Bearbeitet',
  'request_state.TRANSFERRED': 'Übertragen',
  'request_state.CANCELLED': 'Storniert',
  'request_state.REFUSED': 'Abgelehnt',
  'request_state.UNUSABLE': 'Unbrauchbar',
  'request_state.NULL': 'Unbezahlt',
  'request_state.NONE': '-- Kein Filter --',
  'ask.disconnect': 'Sind Sie sicher, dass Sie sich abmelden möchten?',
  'global.yes': 'Ja',
  'applicant.gender.male': 'Männlich',
  'applicant.gender.female': 'Weiblich',
  'applicant.gender.other': 'Andere',
  'marital.status.single': 'Ledig',
  'marital.status.married': 'Verheiratet',
  'marital.status.separated': 'Getrennt',
  'marital.status.divorced': 'Geschieden',
  'marital.status.widowed': 'Verwitwet',
  'marital.status.religiously_married': 'Religiös verheiratet',
  'marital.status.married_according_to_custom': 'Nach den Bräuchen verheiratet',
  'marital.status.other': 'Andere',
  'marital.status.unknown': 'Unbekannt',
  'request_state.PROPOSED': 'Zahlung ausstehend',
  'request_state.PAID': 'Abgeschlossen',
  'request_state.USED': 'Geschlossen',
  'request_state.DUPLICATED': 'Dupliziert',
  'request_state.REFUNDED': 'Erstattet',
  'request_state.EXPIRED': 'Abgelehnt',
  'request_state.PAID_NOT_CONFIRMED': 'Warten auf Überprüfung',
  'request_state.DELAY_PAY_NOT_CONFIRMED': 'Später bezahlen - Nicht bestätigt',
  'request_state.DELAY_PAY': 'Bereit zur Zahlung bei Ankunft',
  'payment_status.DYN.0': 'Zahlung ausstehend',
  'payment_status.DYN.1': 'Bereit zum Einchecken',
  'payment_status.DYN.6': 'Warten auf Überprüfung',
  'payment_status.DYN.2.9': 'Warten auf Aufsicht',
  'payment_status.DYN.2.10': 'Beaufsichtigt',
  'payment_status.desc.DYN.2.10': 'Der Antrag wurde von einem Aufseher geprüft und ist bereit zur Bearbeitung durch den Grenzkontrollbeamten.',
  'payment_status.desc.DYN.2.9': 'Der Antrag wartet auf Aufsicht. Ein Aufseher muss den Antrag möglicherweise prüfen, bevor er vom Grenzkontrollbeamten bearbeitet werden kann.',
  'payment_status.DYN.7': 'Korrektur ausstehend',
  'payment_status.DYN.8': 'Später bezahlen - Nicht bestätigt',
  'payment_status.DYN.9': 'Bereit zur Zahlung bei Ankunft',
  'payment_status.DYN.9.entry': 'Bereit zum Einchecken',
  'payment_status.DYN.9.exit': 'Bereit zum Auschecken',
  'payment_status.DYN.2': 'Ausgecheckt',
  'payment_status.DYN.3': 'Dupliziert',
  'payment_status.DYN.4': 'Erstattet',
  'payment_status.DYN.5': 'Abgelehnt',
  'payment_status.extension.DYN.5': 'Verlängerung abgelehnt',
  'payment_status.DYN.5.blacklisted': 'Abgelehnt - Auf der schwarzen Liste',
  'createPeople.success.DYN.': 'Person erfolgreich erstellt',
  'adminRequestResult.title.DYN.': 'Ausgewählter Antrag - {paymentID}',
  'form.paymentType': 'Zahlungsart',
  'payment.type.online': 'Online',
  'payment.type.offline': 'Offline',
  'request.state.DYN.': 'Antragsstatus',
  'form.birthDate': 'Geburtsdatum',
  'form.birthCountry': 'Geburtsland',
  'form.placeOfBirth': 'Geburtsort',
  'form.residenceAdress': 'Wohnadresse',
  'form.maritalStatus': 'Familienstand',
  'form.departureDate': 'Abreisedatum',
  'form.arrivalDate': 'Ankunftsdatum',
  'form.referencePreviousVisa': 'Referenz des vorherigen Visums',
  'form.passportNumber': 'Passnummer',
  'form.hostName': 'Name des Gastgebers',
  'form.purposeOfVisit': 'Reisezweck',
  'form.previousConvictionsHome': 'Vorstrafen im Heimatland',
  'form.spouse.birthDay': 'Geburtsdatum des Ehepartners',
  'form.spousePassportNumber': 'Passnummer des Ehepartners',
  'form.spousePlaceOfBirth': 'Geburtsort des Ehepartners',
  'form.dependantFullName': 'Vollständiger Name des Abhängigen',
  'form.dependantPassportNumber': 'Passnummer des Abhängigen',
  'form.dependantPlaceOfBirth': 'Geburtsort des Abhängigen',
  'form.dependantBirthDay': 'Geburtsdatum des Abhängigen',
  'form.existingValidEntryReferenceOfficer': 'Eintragungsreferenzbeamter',
  'officer.unknown': 'Unbekannter Beamter',
  'global.approve': 'Genehmigen',
  'global.refuse': 'Ablehnen',
  'global.suspend': 'Überarbeitung anfordern',
  'personal.data': 'Persönliche Daten',
  'contact.data': 'Kontaktdaten',
  'divers.data.DYN.': 'Reisedetails',
  'dependant.data': 'Abhängige Daten',
  'spouse.data': 'Daten des Ehepartners',
  'payment.review.approve.ask.DYN.': 'Möchten Sie diesen Antrag wirklich als <b>EMPFOHLEN</b> überprüfen?',
  'payment.review.refuse.ask.DYN.': 'Möchten Sie diesen Antrag wirklich als <b>NICHT EMPFOHLEN</b> überprüfen?',
  'payment.review.refuse.ask.extension.DYN.': 'Möchten Sie diesen Verlängerungsantrag wirklich als <b>NICHT EMPFOHLEN</b> überprüfen?',
  'payment.review.approve.extension.ask.DYN.': 'Möchten Sie diesen Verlängerungsantrag wirklich <b>GENEHMIGEN</b>?',
  'payment.validate.ask.DYN.': 'Möchten Sie diesen Antrag wirklich <b>GENEHMIGEN</b>?',
  'payment.validate.extension.ask.DYN.': 'Möchten Sie diesen Verlängerungsantrag wirklich <b>GENEHMIGEN</b>?',
  'error.payment.suspend.error.DYN.': 'Beim Aussetzen des Antrags ist ein Fehler aufgetreten.',
  'global.no': 'Nein',
  'global.Yes': 'Ja',
  'global.No': 'Nein',
  'documents': 'Dokumente',
  'data.biographic': 'Biografische Seite des Passes',
  'residence.proof': 'Wohnsitznachweis',
  'address.destination': 'Zieladresse',
  'previous.visa': 'Vorheriges Visum',
  'invite.letter': 'Einladungsschreiben',
  'hostInvitation.letter': 'Einladungsschreiben des Gastgebers',
  'proof.residenceHost': 'Wohnsitznachweis des Gastgebers',
  'hostResidential.status': 'Wohnstatus des Gastgebers',
  'reasonOfVisit.proof': 'Nachweis des Reisezwecks in das Zielland',
  'inviteBusiness.letter': 'Geschäftsbrief des entsendenden Unternehmens',
  'business.profile': 'Berufliches Profil des Reisenden',
  'application.letter': 'Antragsschreiben',
  'acceptanceFromScool.letter': 'Bestätigungsschreiben',
  'date.creation': 'Erstellungsdatum',
  'document.Passport': 'Pass',
  'completeName': 'Vollständiger Name',
  'price': 'Preis',
  'global.retry': 'Erneut versuchen',
  'err.loginWeak': 'Verbindungsproblem, bitte versuchen Sie es erneut',
  'URGENTPASS.title': 'Dringender Reisepass',
  'refusalReason': 'Ablehnungsgrund',
  'error.payment.noRefuseReason': 'Bitte geben Sie eine Nachricht ein.',
  'error.payment.noSuspendReason': 'Bitte geben Sie einen Aussetzungsgrund ein. Dieser Grund wird an den Kunden gesendet.',
  'refusal.desc.DYN.': 'Dieser Antrag wurde abgelehnt.',
  'refusal.desc.extension.DYN.': 'Dieser Verlängerungsantrag wurde abgelehnt.',
  'approval.desc.DYN.': 'Dieser Antrag wurde genehmigt.',
  'approval.desc.extension.DYN.': 'Dieser Verlängerungsantrag wurde genehmigt.',
  'review.approval.desc.DYN.': 'Dieser Antrag erfüllt die Anforderungen.',
  'review.approval.desc.extension.DYN.': 'Dieser Verlängerungsantrag erfüllt die Anforderungen.',
  'review.refusal.desc.DYN.': 'Dieser Antrag erfüllt die Anforderungen nicht.',
  'review.refusal.desc.extension.DYN.': 'Dieser Verlängerungsantrag erfüllt die Anforderungen nicht.',
  'err.getUsers: client.extended.notActiveToken': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
  'VISA_DOUBLE.title': 'Doppeltes Einreisevisum',
  'VISA_KAZA.title': 'Visa Kaza',
  'history': 'Verlauf',
  'menu.people.DYN.': 'Gespeicherte Personen',
  'DYN.XBA': 'African Development Bank',
  'DYN.AGO': 'Angola',
  'DYN.ABW': 'Aruba',
  'DYN.ATG': 'Antigua & Barbuda',
  'DYN.BHS': 'Bahamas',
  'DYN.BRB': 'Barbados',
  'DYN.BLZ': 'Belize',
  'DYN.BWA': 'Botswana',
  'DYN.CYM': 'Kaimaninseln',
  'DYN.CYP': 'Zypern',
  'DYN.FJI': 'Fidschi',
  'DYN.COD': 'Demokratische Republik Kongo',
  'DYN.GHA': 'Ghana',
  'DYN.GRD': 'Grenada',
  'DYN.HKG': 'Sonderverwaltungsregion Hongkong (China)',
  'DYN.KEN': 'Kenia',
  'DYN.KIR': 'Kiribati',
  'DYN.JAM': 'Jamaika',
  'DYN.LDW': 'Inseln über dem Winde',
  'DYN.LSO': 'Lesotho',
  'DYN.MDG': 'Madagaskar',
  'DYN.MWI': 'Malawi',
  'DYN.MYS': 'Malaysia',
  'DYN.MDV': 'Malediven',
  'DYN.MLT': 'Malta',
  'DYN.MUS': 'Mauritius',
  'DYN.MSR': 'Montserrat',
  'DYN.MOZ': 'Mosambik',
  'DYN.NAM': 'Namibia',
  'DYN.NRU': 'Nauru',
  'DYN.LCA': 'St. Lucia',
  'DYN.VCT': 'St. Vincent und die Grenadinen',
  'DYN.WSM': 'West-Samoa',
  'DYN.SYC': 'Seychellen',
  'DYN.SGP': 'Singapur',
  'DYN.SLB': 'Salomonen',
  'DYN.ZAF': 'Südafrika',
  'DYN.KNA': 'St. Kitts und Nevis',
  'DYN.SWZ': 'Swasiland',
  'DYN.TON': 'Tonga',
  'DYN.TTO': 'Trinidad und Tobago',
  'DYN.TCA': 'Turks- und Caicosinseln',
  'DYN.TUV': 'Tuvalu',
  'DYN.UGA': 'Uganda',
  'DYN.TZA': 'Vereinigte Republik Tansania',
  'DYN.VUT': 'Vanuatu',
  'DYN.VAT': 'Vatikan',
  'DYN.VEN': 'Venezuela (Bolivarische Republik)',
  'DYN.USA': 'Vereinigte Staaten von Amerika',
  'DYN.URY': 'Uruguay',
  'DYN.UZB': 'Usbekistan',
  'DYN.UKR': 'Ukraine',
  'DYN.ARE': 'Vereinigte Arabische Emirate',
  'DYN.GBR': 'Vereinigtes Königreich Großbritannien und Nordirland',
  'DYN.TUR': 'Türkei',
  'DYN.TKM': 'Turkmenistan',
  'DYN.SWE': 'Schweden',
  'DYN.CHE': 'Schweiz',
  'DYN.TJK': 'Tadschikistan',
  'DYN.KAZ': 'Kasachstan',
  'DYN.SUR': 'Suriname',
  'DYN.ESP': 'Spanien',
  'DYN.SVK': 'Slowakei',
  'DYN.SVN': 'Slowenien',
  'DYN.SEN': 'Senegal',
  'DYN.SRB': 'Serbien',
  'DYN.SMR': 'San Marino',
  'DYN.STP': 'São Tomé und Príncipe',
  'DYN.NLD': 'Niederlande',
  'DYN.NCL': 'Neukaledonien',
  'DYN.NZL': 'Neuseeland',
  'DYN.NIC': 'Nicaragua',
  'DYN.MEX': 'Mexiko',
  'DYN.FSM': 'Mikronesien, Föderierte Staaten von',
  'DYN.MDA': 'Republik Moldau',
  'DYN.MCO': 'Monaco',
  'DYN.MHL': 'Marshallinseln',
  'DYN.LVA': 'Lettland',
  'DYN.NFK': 'Norfolkinsel',
  'DYN.MNP': 'Nördliche Marianen',
  'DYN.NOR': 'Norwegen',
  'DYN.PLW': 'Palau',
  'DYN.PSE': 'Palästina',
  'DYN.PAN': 'Panama',
  'DYN.PNG': 'Papua-Neuguinea',
  'DYN.PRY': 'Paraguay',
  'DYN.PER': 'Peru',
  'DYN.POL': 'Polen',
  'DYN.PRT': 'Portugal',
  'DYN.PRI': 'Puerto Rico',
  'DYN.REU': 'Réunion',
  'DYN.ROU': 'Rumänien',
  'DYN.RUS': 'Russische Föderation',
  'DYN.RWA': 'Ruanda',
  'DYN.LIE': 'Liechtenstein',
  'DYN.LTU': 'Litauen',
  'DYN.LUX': 'Luxemburg',
  'DYN.MAC': 'Sonderverwaltungsregion Macau (China)',
  'DYN.JPN': 'Japan',
  'DYN.KWT': 'Kuwait',
  'DYN.KGZ': 'Kirgisistan',
  'DYN.KOR': 'Südkorea',
  'DYN.GUY': 'Guyana',
  'DYN.HTI': 'Haiti',
  'DYN.HND': 'Honduras',
  'DYN.IRL': 'Irland',
  'DYN.ISR': 'Israel',
  'DYN.ITA': 'Italien',
  'DYN.HUN': 'Ungarn',
  'DYN.ISL': 'Island',
  'DYN.IND': 'Indien',
  'DYN.IDN': 'Indonesien',
  'DYN.IRN': 'Iran',
  'DYN.GUM': 'Guam',
  'DYN.GTM': 'Guatemala',
  'DYN.GIB': 'Gibraltar',
  'DYN.GRC': 'Griechenland',
  'DYN.GEO': 'Georgien',
  'DYN.DEU': 'Deutschland',
  'DYN.DNK': 'Dänemark',
  'DYN.EST': 'Estland',
  'DYN.ETH': 'Äthiopien',
  'DYN.FIN': 'Finnland',
  'DYN.FRA': 'Frankreich',
  'DYN.GUF': 'Französisch-Guayana',
  'DYN.PYF': 'Französisch-Polynesien',
  'DYN.ATF': 'Französische Süd- und Antarktisgebiete',
  'DYN.CZE': 'Tschechische Republik',
  'DYN.COM': 'Komoren',
  'DYN.DOM': 'Dominikanische Republik',
  'DYN.ECU': 'Ecuador',
  'DYN.EGY': 'Ägypten',
  'DYN.SLV': 'El Salvador',
  'DYN.GNQ': 'Äquatorialguinea',
  'DYN.CHL': 'Chile',
  'DYN.CHN': 'China',
  'DYN.CHN_NT': 'China (nicht touristisch)',
  'DYN.COK': 'Cookinseln',
  'DYN.CRI': 'Costa Rica',
  'DYN.HRV': 'Kroatien',
  'DYN.CUB': 'Kuba',
  'DYN.BDI': 'Burundi',
  'DYN.CAN': 'Kanada',
  'DYN.CPV': 'Kap Verde',
  'DYN.BRA': 'Brasilien',
  'DYN.VGB': 'Britische Jungferninseln',
  'DYN.BRN': 'Brunei Darussalam',
  'DYN.BGR': 'Bulgarien',
  'DYN.BMU': 'Bermuda',
  'DYN.BTN': 'Bhutan',
  'DYN.BIH': 'Bosnien und Herzegowina',
  'DYN.BLR': 'Weißrussland',
  'DYN.BEL': 'Belgien',
  'DYN.BHR': 'Bahrain',
  'DYN.ARG': 'Argentinien',
  'DYN.ARM': 'Armenien',
  'DYN.AUS': 'Australien',
  'DYN.AUT': 'Österreich',
  'DYN.AZE': 'Aserbaidschan',
  'DYN.ALB': 'Albanien',
  'DYN.DZA': 'Algerien',
  'DYN.AIA': 'Anguilla',
  'DYN.BGD': 'Bangladesch',
  'DYN.BEN': 'Benin',
  'DYN.AFG': 'Afghanistan',
  'DYN.BOL': 'Bolivien',
  'DYN.BFA': 'Burkina Faso',
  'DYN.KHM': 'Kambodscha',
  'DYN.CMR': 'Kamerun',
  'DYN.CIV': 'Elfenbeinküste',
  'DYN.CAF': 'Zentralafrikanische Republik',
  'DYN.TCD': 'Tschad',
  'DYN.COL': 'Kolumbien',
  'DYN.ERI': 'Eritrea',
  'DYN.COG': 'Kongo-Brazzaville',
  'DYN.PRK': 'Demokratische Volksrepublik Korea',
  'DYN.GAB': 'Gabun',
  'DYN.GMB': 'Gambia',
  'DYN.DJI': 'Dschibuti',
  'DYN.GIN': 'Guinea-Conakry',
  'DYN.GNB': 'Guinea-Bissau',
  'DYN.IRQ': 'Irak',
  'DYN.KOS': 'Kosovo',
  'DYN.LAO': 'Laos',
  'DYN.JOR': 'Jordanien',
  'DYN.LBR': 'Liberia',
  'DYN.LBY': 'Libysch-Arabische Dschamahirija',
  'DYN.MLI': 'Mali',
  'DYN.QAT': 'Katar',
  'DYN.REF': 'Flüchtling',
  'DYN.PHL': 'Philippinen',
  'DYN.OMN': 'Oman',
  'DYN.PAK': 'Pakistan',
  'DYN.LBN': 'Libanon',
  'DYN.MRT': 'Mauretanien',
  'DYN.MNG': 'Mongolei',
  'DYN.MNE': 'Montenegro',
  'DYN.NER': 'Niger',
  'DYN.NGA': 'Nigeria',
  'DYN.MMR': 'Myanmar',
  'DYN.MAR': 'Marokko',
  'DYN.NPL': 'Nepal',
  'DYN.SAU': 'Saudi-Arabien',
  'DYN.SLE': 'Sierra Leone',
  'DYN.SOM': 'Somalia',
  'DYN.LKA': 'Sri Lanka',
  'DYN.SSD': 'Südsudan',
  'DYN.SDN': 'Sudan',
  'DYN.THA': 'Thailand',
  'DYN.MKD': 'Ehemalige jugoslawische Republik Mazedonien',
  'DYN.TGO': 'Togo',
  'DYN.SYR': 'Syrien',
  'DYN.TWN': 'Taiwan',
  'DYN.TUN': 'Tunesien',
  'DYN.VNM': 'Vietnam',
  'DYN.YEM': 'Jemen',
  'DYN.TLS': 'Timor-Leste',
  'DYN.AND': 'Andorra',
  'DYN.VIR': 'Amerikanische Jungferninseln',
  'DYN.XKX': 'Kosovo',
  'DYN.ZWE': 'Simbabwe',
  'DYN.ZMB': 'Sambia',
  'DYN.ASM': 'Amerikanisch-Samoa',
  'DYN.DMA': 'Dominica',
  'DYN.XXA': 'Staatenlos',
  'DYN.XXB': 'Flüchtling (Genfer Konvention)',
  'DYN.XXC': 'Flüchtling (Andere)',
  'DYN.UNA': 'Agentur der Vereinten Nationen',
  'DYN.UNO': 'Organisation der Vereinten Nationen',
  'document.type.DYN.': 'Antragsart',
  'dependantIndex': 'Abhängiger {index}',
  'form.spouseFullName': 'Vollständiger Name des Ehepartners',
  'qrDesc.valid': 'Zeigen Sie diesen QR-Code bei der Visa-Kontrolle beim Ein- oder Ausreisen vor. Sie können nicht ohne einen gültigen QR-Code reisen.',
  'err.pay': 'Während der Zahlung ist ein Fehler aufgetreten. Versuchen Sie es erneut.',
  'payment.noEvents': 'Dieser Antrag beinhaltet derzeit keine reisebezogene Bearbeitung (Verwendungen des Antrags).',
  'global.cancel': 'Abbrechen',
  'end.suspend': 'Überprüfung abschließen',
  'trips.title': 'Anträge verfolgen',
  'trips.desc': 'Antrag/Anträge',
  'BatchId': 'Antragsreferenz',
  'newBatchId.desc': 'Bitte geben Sie einen Namen für diese Reise ein.',
  'personLinkType.DYN.0': 'Unbekannt',
  'personLinkType.DYN.1': 'Kind',
  'personLinkType.DYN.2': 'Elternteil',
  'personLinkType.DYN.3': 'Ehepartner',
  'personLinkType.DYN.4': 'Sonstiges',
  'personLinkType.DYN.5': 'Selbst',
  'batchIds.desc': 'Anträge, die mit der Referenz {trip} verknüpft sind:',
  'trip.name': 'Antragsreferenz',
  'visaIntro.validFrom': 'Startdatum',
  'visaIntro.validUntil': 'Ablaufdatum',
  'visaIntro.usageCount': 'Erlaubte Verwendung(en)',
  'client.extended.passportNumberAlreadyExists': 'Diese Reisepassnummer wird bereits verwendet. Bitte geben Sie eine andere ein.',
  'client.extended.alreadyDecided': 'Dieser Antrag wurde bereits von Ihnen überprüft. Sie können ihn nicht erneut überprüfen.',
  'client.extended.outOfUsage': 'Dieser Antrag befindet sich <b>außerhalb seines Gültigkeitszeitraums</b>',
  'global.review': 'Überprüfung',
  'error.review.noChoice': 'Bitte wählen Sie einen Überprüfungsstatus, um fortzufahren.',
  'all.reviews': 'Alle Überprüfungen dieses Antrags',
  'all.reviews.extension': 'Alle Überprüfungen dieses Verlängerungsantrags',
  'validate.desc': 'Dieser Antrag wurde am {date} vom Benutzer als genehmigt bewertet',
  'validate.extension.desc': 'Dieser Verlängerungsantrag wurde am {date} vom Benutzer als genehmigt bewertet',
  'refusal.review.desc': 'Dieser Antrag wurde am {date} vom Benutzer als abgelehnt bewertet',
  'refusal.review.extension.desc': 'Dieser Verlängerungsantrag wurde am {date} vom Benutzer als abgelehnt bewertet',
  'refusal.review.desc.blacklisted': 'Dieser Antrag wurde am {date} vom Benutzer als abgelehnt und auf die schwarze Liste gesetzt bewertet',
  'approve.text': 'Dieser Antrag wurde genehmigt.',
  'pending.review.desc': 'Eine Korrektur dieses Antrags wurde dem Antragsteller am {date} vom Benutzer angefordert',
  'global.reason': 'Grund',
  'pending.desc': 'Dieser Antrag wartet derzeit auf eine Korrektur des Kunden.',
  'successRequest.title': 'Antrag erfolgreich übermittelt',
  'amountDue': 'Preis: ',
  'amountDue.total.now': 'Jetzt fälliger Gesamtbetrag: ',
  'amountDue.total.later': 'Gesamtbetrag am Schalter: ',
  'noPrint.mobile': 'Das Drucken von Seiten wird auf Mobilgeräten nicht unterstützt',
  'onArrival.reset': 'Neuen Prozess starten',
  'onArrival.reset.ask': 'Möchten Sie wirklich einen neuen Prozess starten?',
  'stillHere': 'Sind Sie noch da? Dieser Prozess wird sich in 20 Sekunden zurücksetzen.',
  'print.request': 'Antrag drucken',
  'EXPIRED.globalExplain': 'Dieser Antrag wurde abgelehnt. Er entspricht nicht unseren Standards.',
  'payment_status.desc.DYN.7': 'Dieser Antrag wartet auf eine Korrektur des Kunden.',
  'payment_status.DYN.6.review': 'Bewertung ausstehend - {reviewCount}/2',
  'payment_status.extension.DYN.6': 'Bewertung ausstehend',
  'payment_status.extension.DYN.6.review': 'Bewertung ausstehend - {reviewCount}/1',
  'payment_status.desc.DYN.6.review': 'Dieser Antrag wartet derzeit auf eine Überprüfung. Er wurde bereits {reviewCount} Mal überprüft.',
  'payment_status.DYN.6.finalReview': 'Endgültige Überprüfung ausstehend',
  'payment_status.extension.DYN.6.finalReview': 'Endgültige Überprüfung ausstehend',
  'payment_status.desc.DYN.6.finalReview': 'Dieser Antrag wurde überprüft und wartet derzeit auf die endgültige Überprüfung.',
  'payment_status.desc.DYN.0': 'Dieser Antrag wartet derzeit auf die Zahlungsgenehmigung durch die Zahlungsstelle. Falls die Zahlung noch nicht erfolgt ist, kann sie jetzt abgeschlossen werden.',
  'payment_status.desc.DYN.5': 'Dieser Antrag wurde abgelehnt.',
  'payment_status.desc.DYN.5.blacklisted': 'Dieser Antrag wurde abgelehnt und die Person wurde auf die schwarze Liste gesetzt.',
  'payment_status.desc.DYN.5.checkIn': 'Dieser Antrag wurde bei der Kontrolle am Schalter abgelehnt.',
  'payment_status.desc.DYN.5.checkIn.reason': 'Dieser Antrag wurde bei der Kontrolle am Schalter abgelehnt. <p><b>Grund</b>: <br/> {reason}</p>',
  'payment_status.DYN.5.checkIn': 'Bei der Kontrolle abgelehnt',
  'payment_status.desc.DYN.5.checkOut': 'Dieser Antrag wurde bei der Ausreise am Schalter abgelehnt.',
  'payment_status.DYN.5.checkOut': 'Bei der Ausreise abgelehnt',
  'payment_status.desc.DYN.9': 'Dieser Antrag ist am Schalter zur Zahlung bereit. Der Check-in kann nach der Zahlung abgeschlossen werden.',
  'payment_status.desc.DYN.9.entry': 'Dieser Antrag ist bereit zum Check-in am Schalter.',
  'payment_status.desc.DYN.9.exit': 'Dieser Antrag ist bereit zur Ausreise und erfordert die Zahlung des Grenzübergangspasses am Schalter.',
  'payment_status.DYN.2.out': 'Bereit zur Ausreise',
  'payment_status.DYN.2.outFinish': 'Ausgereist',
  'payment_status.DYN.2.closed': 'Geschlossen',
  'payment_status.desc.DYN.2.closed': 'Dieser Antrag wurde geschlossen.',
  'payment_status.desc.DYN.2.zweexit': 'Dieser Antrag ist bereit zur Ausreise am Schalter.',
  'payment_status.DYN.2.entryFinish': 'Eingecheckt',
  'payment_status.DYN.2.in': 'Bereit zum Check-in',
  'payment_status.desc.DYN.2.out': 'Dieser Antrag wurde eingecheckt. Der nächste Schritt ist der Check-out am Schalter.',
  'payment_status.desc.DYN.2.outFinish': 'Dieser Antrag wurde ausgecheckt. Der Kunde kann jetzt reisen.',
  'payment_status.desc.DYN.2.entryFinish': 'Dieser Antrag wurde eingecheckt. Der Kunde kann jetzt ins Land einreisen.',
  'payment_status.desc.DYN.2.in': 'Dieser Antrag wartet auf den Check-in am Schalter.',
  'ask.isArrivalPaid': 'Die folgende Zahlung muss jetzt in einer der folgenden Währungen bezahlt werden:',
  'ask.isArrivalPaid.exit': 'Der Grenzübergangspass muss jetzt in einer der folgenden Währungen bezahlt werden:',
  'ask.isArrivalPaid.confirm.exit': 'Bestätigen Sie, dass die Zahlung erfolgt ist? Wenn Sie dies bestätigen, geben Sie bitte die Zahlungsreferenz und die verwendete Währung ein.',
  'ask.checkoutExpired.confirm': 'Bestätigen Sie, dass die Zahlung erfolgt ist? Wenn Sie dies bestätigen, geben Sie bitte die Zahlungsreferenz und die verwendete Währung ein.',
  'no_trips': 'Sie haben keine Reisen.',
  'err.canActivate': 'Ein Fehler ist aufgetreten',
  'form.passportNumber.dateOfIssue': 'Ausstellungsdatum des Reisepasses',
  'form.passportNumber.dateOfExpiry': 'Ablaufdatum des Reisepasses',
  'form.passportNumber.placeOfIssue': 'Ausstellungsort des Reisepasses',
  'nextOfKin.data': 'Notfallkontakt / Nächster Angehöriger',
  'form.otherLinkType': 'Geben Sie den Beziehungstyp an',
  'camera.problem.manual': 'Sie sind dabei, diesen Antrag ohne ein Bild des Kunden ein- oder auszuchecken. Möchten Sie wirklich fortfahren?',
  'camera.problem.button': 'Problem mit der Kamera?',
  'global.noFilter': '--Kein Filter--',
  'zweentry': 'Einreise ohne Visum',
  'zweentry.title': 'Einreise ohne Visum',
  'free.charge': 'Kostenlos',
  'camera.init.error': 'Beim Initialisieren der Kamera ist ein Fehler aufgetreten. Möchten Sie diesen Antrag ohne ein Bild des Kunden ein- oder auschecken?',
  'error.payment.noPaymentReference': 'Bitte geben Sie eine Zahlungsreferenz, eine Zahlungsmethode und die verwendete Währung ein.',
  'paymentReference.ask': 'Zahlungsreferenz',
  'paymentReference.askExpired': 'Zahlungsreferenz für die Überziehungsgebühr',
  'session.expired': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
  'phone.pattern': ' (z.B.: +263771234567)',
  'global.receipt.id': 'ID des Antrags: {paymentId}',
  'ask.place.updatePermissions': 'Sind Sie sicher, dass Sie die Berechtigungen dieses Ortes aktualisieren möchten?',
  'place.updatePermissions.success': 'Die Berechtigungen des Ortes wurden erfolgreich aktualisiert.',
  'err.place.updatePermissions': 'Beim Aktualisieren der Berechtigungen des Ortes ist ein Fehler aufgetreten.',
  'global.urgent': 'Dringend',
  'form.usageAfter': 'Gültig ab',
  'form.usageUntil': 'Gültig bis',
  'form.localUsageUntil': 'Maximales Enddatum des Aufenthalts',
  'form.timeslot': 'Zeitfenster',
  'internalReference': 'HQ-Referenz',
  'payment_status.DYN.6.0': 'Bewertung ausstehend 0/2',
  'payment_status.DYN.6.1': 'Bewertung ausstehend 1/2',
  'payment_status.DYN.6.2': 'Endgültige Überprüfung ausstehend',
  'payment_status.DYN.8.0': 'Später bezahlen - Nicht bestätigt',
  'payment_status.DYN.2.0': 'Eingecheckt',
  'payment_status.DYN.2.4': 'Bereit zum Auschecken',
  'payment_status.DYN.2.5': 'Ausgecheckt',
  'payment_status.DYN.2.6': 'Bei der Einreise abgelehnt',
  'payment_status.DYN.2.7': 'Bei der Ausreise abgelehnt',
  'payment_status.DYN.2.8': 'Geschlossen',
  'payment_status.extension.DYN.6.0': 'Warten auf Online-Überprüfung 0/1',
  'payment_status.extension.DYN.6.2': 'Warten auf endgültige Online-Überprüfung',
  'payment_status.extension.DYN.7': 'Warten auf Korrektur',
  'payment_status.extension.DYN.9': 'Verlängerung bestätigt',
  'payment_status.extension.DYN.0': 'Zahlung ausstehend',
  'internalReference.create': 'HQ-Referenz hinzufügen',
  'internalReference.edit': 'HQ-Referenz bearbeiten',
  'timeslot.set': 'Zeitfenster festlegen',
  'timeslot.setNew': 'Neues Zeitfenster festlegen',
  'internalReference.ask.edit': 'Bitte geben Sie die neue HQ-Referenz ein.',
  'internalReference.ask.create': 'Bitte geben Sie die HQ-Referenz ein.',
  'internalReference.done.create': 'Die HQ-Referenz wurde erfolgreich hinzugefügt.',
  'internalReference.done.edit': 'Die HQ-Referenz wurde erfolgreich bearbeitet.',
  'error.internalReference': 'Beim Hinzufügen/Bearbeiten der HQ-Referenz ist ein Fehler aufgetreten.',
  'error.paymentUntil.expired': 'Dieser Antrag befindet sich außerhalb seines Gültigkeitszeitraums. Sie können jedoch mit dem Auschecken des Kunden fortfahren. Bitte beachten Sie, dass aufgrund des abgelaufenen Antrags eine Gebühr von 100 USD erforderlich ist. Die Zahlung muss sofort in einer der folgenden Währungen erfolgen:',
  'internalReference.desc': 'Fügen Sie diesem Antrag eine HQ-Referenz hinzu (z.B. 140_2024).',
  'titlePrint': 'Antrag </br> <b>{paymentID}</b>',
  'title.visaReference': 'Verknüpfte Anwendung',
  'titlePrint.extension': 'Verlängerungsantrag </br> <b>{paymentID}</b>',
  'globalStatus.valid': 'Gültig',
  'PENDING.globalExplain': 'Dieser Antrag wartet auf eine Korrektur. Bitte überprüfen Sie die Informationen und korrigieren Sie sie.',
  'PAID_NOT_CONFIRMED.globalExplain': 'Dieser Antrag wartet auf die Bestätigung durch unsere Dienste.',
  'PROPOSED.globalExplain': 'Dieser Antrag wartet auf die Zahlung. Wenn Sie die Zahlung noch nicht validiert haben, können Sie dies jetzt tun.',
  'afterWithoutUntil': 'Sie dürfen ab {dateAfter} bis {deadlineDate} einreisen.',
  'afterWithoutUntilAndMillis': 'Sie dürfen ab {dateAfter} reisen.',
  'afterAndUntil': 'Sie dürfen ab {dateAfter} bis {dateUntil} reisen.',
  'photo.current': 'Aktuelles Bild',
  'photo.scanned': 'Aus dem Reisepass gescanntes Bild',
  'createdAt': 'Erstellungsdatum',
  'all.infos': 'Informationen zu diesem Antrag',
  'afterRefused': 'Erklärte Reisedaten: {dateAfter}.',
  'DYN.paymentError.desc.success': '<p>Ihre Bestellung wurde erfolgreich aufgenommen. Sollte ein Teil dieses Antrags die Genehmigung durch unser Team erfordern, werden Sie benachrichtigt, sobald dieser Vorgang abgeschlossen ist. Andernfalls wissen Sie bitte, dass wir Ihre Anfrage erhalten haben.</p> <p><b>Vielen Dank, dass Sie sich für unsere Dienste entschieden haben.</b></p>',
  'sinceOneWeek': 'Bitte beachten Sie, dass dieses Dokument seit über einer Woche im Überprüfungsstatus wartet.',
  'client.extended.onlyAdminDecide': 'Dieser Antrag wurde bereits von einem Mitarbeiter mit dem gleichen Dienstalter wie Sie überprüft. Sie können ihn nicht erneut überprüfen.',
  'error.paymentUntil.before': 'Das Datum ist zu früh. Dieser Antrag wird ab {dateAfter} gültig sein.',
  'applicant.gender.FEMALE': 'Weiblich',
  'applicant.gender.MALE': 'Männlich',
  'entry.consume': 'Ankünfte',
  'exit.consume': 'Abreisen',
  'scan.noConsumeMode': 'Als Grenzbeamter sind Sie für die Verwaltung von sowohl Einreisen als auch Ausreisen verantwortlich. Bitte wählen Sie die Option, die Ihrer aktuellen Aufgabe entspricht: Ankünfte bearbeiten oder Abreisen verwalten.',
  'scan.noVisaFound': 'Für diese Person wurde kein Datensatz im Status "Bereit zum Auschecken" für eine Ausreise gefunden. Möchten Sie einen neuen Antrag für die Ausreise erstellen?',
  'zweexit': 'Ausreise ohne Visum',
  'err.scanPassport': 'Beim Scannen des Reisepasses ist ein Fehler aufgetreten. Bitte stellen Sie sicher, dass er richtig eingeführt ist, und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, starten Sie die Anwendung neu oder kontaktieren Sie den Support.',
  'exit.register': 'Ausreise registrieren',
  'entry.register': 'Einreise registrieren',
  'exit.create': 'Ausreise ohne Visum erstellen',
  'exit.ask': 'Möchten Sie wirklich eine Ausreise ohne Visum für diese Person registrieren?',
  'border': 'Grenzbeamter',
  'global.signout': 'Abmelden',
  'search.manually': 'Antrag suchen',
  'scan.applicationQr': 'Antrag QR scannen',
  'err.client.extended.maxUsageCountReached': 'Die maximale Anzahl der Verwendungen für diesen Antrag wurde erreicht.',
  'form.firstName.scanned': 'Gescannten Vorname(n)',
  'form.lastName.scanned': 'Gescannten Nachname',
  'form.documentNumber.scanned': 'Gescannten Reisepassnummer',
  'form.gender.scanned': 'Gescanntes Geschlecht',
  'form.birthDate.scanned': 'Gescanntes Geburtsdatum',
  'form.nationality.scanned': 'Gescannten Nationalität',
  'form.nationality': 'Staatsangehörigkeit',
  'application.data': 'Antragsdaten',
  'no.passportPhoto': 'Kein Foto',
  'overstay': 'Überziehung',
  'method.payment': 'Zahlungsmethode',
  'review.desc': 'Genehmigen/Ablehnen',
  'approval.usageUntil.DYN.': 'Ändern Sie das Ablaufdatum (optional)',
  'scanned.list': 'Liste der gefundenen Anträge',
  'scanned.recommended': 'Empfohlen',
  'scanned.entriesUsed': 'Einträge verwendet',
  'scanned.paid': 'Bezahlt',
  'visa.blacklist': 'Dieser Visumantrag wurde auf die schwarze Liste gesetzt. Die Person darf nicht in das Land einreisen.',
  'scan.noEntryFound': 'Für diese Person wurde kein Datensatz im Status "Bereit zum Einchecken" für eine Einreise gefunden. Möchten Sie einen neuen Antrag zum Einchecken erstellen?',
  'global.syncing': 'Synchronisierung...',
  'payment.consume.error.DYN.': 'Beim Bearbeiten des Antrags ist ein Fehler aufgetreten.',
  'tooltip.changeTimeslot': 'Zeitfenster ändern',
  'tooltip.transit': 'Aktivieren Sie dieses Kontrollkästchen, um den Transit als Grenzbeamter zu verwalten.',
  'tooltip.Qr': 'Sie können den mit einem Antrag verknüpften QR-Code direkt scannen, um detaillierte Informationen zu diesem Antrag zu finden.',
  'tooltip.arrivals': 'Aktivieren Sie dieses Kontrollkästchen, um Ankünfte als Grenzbeamter zu verwalten.',
  'tooltip.departures': 'Aktivieren Sie dieses Kontrollkästchen, um Abreisen als Grenzbeamter zu verwalten.',
  'tooltip.searchManually': 'Suchen Sie nach einem bestimmten Antrag anhand verschiedener Kriterien.',
  'tooltip.signout': 'Aus der Anwendung abmelden.',
  'tooltip.my_account': 'Zugriff auf Ihre Kontoeinstellungen.',
  'tooltip.dashboard': 'Zugriff auf das Dashboard.',
  'tooltip.createRequests': 'Einen neuen Antrag erstellen.',
  'tooltip.trips': 'Den Status Ihrer Anträge einsehen und das verknüpfte Dokument bei Genehmigung drucken.',
  'tooltip.people': 'Die mit Ihrem Konto verknüpften Personen verwalten.',
  'tooltip.users': 'Die Benutzer der Anwendung verwalten.',
  'tooltip.places': 'Die Orte der Anwendung verwalten.',
  'tooltip.role': 'Ihre Rolle und Ihr Name in der Anwendung.',
  'tooltip.exitRegister': 'Manuell eine Ausreise ohne Visum für eine Person registrieren.',
  'tooltip.entryRegister': 'Manuell eine Einreise ohne Visum für eine Person registrieren.',
  'tooltip.support': 'Den Support für Hilfe bei Problemen kontaktieren.',
  'tooltip.chooseLang': 'Die Sprache der Anwendung ändern. Derzeit ist nur Englisch verfügbar.',
  'tooltip.changePassword': 'Ihr Passwort ändern.',
  'tooltip.internalReferenceNoFilter': 'Klicken Sie auf eine interne Referenz, falls verfügbar, um zur verknüpften Referenz weitergeleitet zu werden.',
  'tooltip.state': 'Die Anträge basierend auf ihrem Status filtern.',
  'tooltip.tableBatchId': 'Die mit dem Antrag verknüpfte Antragsreferenz',
  'tooltip.tableState': 'Der Status des Antrags',
  'tooltip.tableUsageAfter': 'Das Startdatum des Antrags',
  'tooltip.tableUsageUntil': 'Das Ablaufdatum des Antrags',
  'tooltip.history': 'Die Zahlungshistorie Ihrer Anträge.',
  'tooltip.addPerson': 'Eine neue Person hinzufügen, die mit Ihrem Konto verknüpft ist.',
  'tooltip.urgent': 'Dies bedeutet, dass der Antrag als dringend markiert ist und so bald wie möglich bearbeitet werden sollte.',
  'tooltip.operationId': 'Die Art des Antrags.',
  'tooltip.purposeOfVisit': 'Der Zweck des Besuchs für diesen Antrag.',
  'tooltip.amount': 'Der Preis dieses Antrags.',
  'tooltip.paymentType': 'Die Art der Zahlung für diesen Antrag.',
  'tooltip.paymentReference': 'Die Zahlungsreferenz für diesen Antrag.',
  'tooltip.review': 'Diesen Antrag als genehmigt oder abgelehnt überprüfen und einen Kommentar hinzufügen.',
  'tooltip.revision': 'Den Kunden auffordern, den Antrag zu korrigieren.',
  'tooltip.approve': 'Diesen Antrag als endgültige Entscheidung genehmigen. Sie können auch einen Kommentar hinzufügen. Wenn der Begriff "schwarze Liste" vorhanden ist, wird die Person auf die schwarze Liste gesetzt.',
  'tooltip.refuse': 'Diesen Antrag als endgültige Entscheidung ablehnen. Sie können auch einen Kommentar hinzufügen.',
  'tooltip.qrSee': 'Den QR-Code dieses Antrags anzeigen und das damit verknüpfte Dokument drucken.',
  'tooltip.internalEdit': 'Die interne Referenz dieses Antrags bearbeiten.',
  'tooltip.internalAdd': 'Eine interne Referenz zu diesem Antrag hinzufügen.',
  'tooltip.printApplication': 'Den Antrag mit allen Informationen drucken.',
  'tooltip.allReviews': 'Alle Bewertungen dieses Antrags mit Datum und Benutzer, der die Bewertung durchgeführt hat.',
  'tooltip.version': 'Die aktuelle Version der Anwendung.',
  'tooltip.consumeProfile.IN': 'Das am Einreiseort aufgenommene Bild.',
  'tooltip.consumeNoProfile.IN': 'Kein am Einreiseort aufgenommenes Bild.',
  'tooltip.consumeTime.IN': 'Datum und Uhrzeit des Einreiseortes.',
  'tooltip.consumePlace.IN': 'Der Einreiseort.',
  'tooltip.consumeProfile.OUT': 'Das am Ausreiseort aufgenommene Bild.',
  'tooltip.consumeNoProfile.OUT': 'Kein am Ausreiseort aufgenommenes Bild.',
  'tooltip.consumeTime.OUT': 'Datum und Uhrzeit des Ausreiseortes.',
  'tooltip.consumePlace.OUT': 'Der Ausreiseort.',
  'tooltip.passportComparison': 'Aus dem Reisepass gescannte Informationen. Sie ermöglichen den Vergleich der Informationen mit den tatsächlichen Informationen des Antrags.',
  'tooltip.classicComparison': 'Aktuelle Informationen des Antrags. Sie ermöglichen den Vergleich der Informationen mit den gescannten Informationen aus dem Reisepass.',
  'tooltip.trackingApplicationReference': 'Antragsreferenz dieser Anträge',
  'tooltip.allTrackingInfo': 'Alle Informationen zu diesem Antrag',
  'tooltip.trackingPrint': 'Das mit diesem Antrag verknüpfte Dokument drucken',
  'tooltip.docFirstName': 'Geben Sie den Vornamen der Person ein, wie er im Reisepass erscheint.',
  'tooltip.docLastName': 'Geben Sie den Nachnamen der Person ein, wie er im Reisepass erscheint.',
  'tooltip.docPassportNumber': 'Geben Sie die Reisepassnummer der Person ein.',
  'tooltip.docLinkType': 'Wählen Sie den Beziehungstyp, den Sie zu der Person haben.',
  'tooltip.docLinkTypeOther': 'Geben Sie den Beziehungstyp an, den Sie zu der Person haben.',
  'tooltip.applicationReferenceRequest': 'Die Antragsreferenz der Anfrage. Sie ist für jede Anfrage einzigartig und wird automatisch generiert.',
  'tooltip.portEntryRequest': 'Der Einreisehafen der Anfrage. Es ist der Ort, an dem die Person in das Land einreisen wird.',
  'tooltip.otherName': 'Geben Sie den anderen Namen des Antragstellers ein, wie er im Reisepass erscheint.',
  'tooltip.spouseCheckbox': 'Aktivieren Sie dieses Kontrollkästchen, wenn der Antragsteller einen Ehepartner hat, und füllen Sie die unten stehenden Informationen aus.',
  'tooltip.hostName': 'Der Name der Person/Organisation, die den Antragsteller beherbergen wird.',
  'tooltip.scanPassport': 'Scannen Sie den Reisepass des Antragstellers, um einen Antrag zu finden, der mit diesem Reisepass verknüpft ist. Wenn kein Antrag gefunden wird, können Sie einen neuen erstellen.',
  'tooltip.passportScanned': 'Die aus dem Reisepass gescannten Informationen.',
  'tooltip.scannedCard': 'Ähnliche Anträge, die mit den gescannten Informationen gefunden wurden.',
  'scan.error': 'Beim Scannen des Dokuments ist ein Fehler aufgetreten.',
  'tooltip.webcamProblems': 'Wenn die Kamera nicht richtig funktioniert, können Sie den Antrag dennoch ohne Bild ein- oder auschecken.',
  'tooltip.checkOut': 'Die Person aus dem Land auschecken.',
  'err.ResidencePermitNumber.pattern': 'Die Aufenthaltsgenehmigungsnummer darf nur aus Großbuchstaben und Ziffern bestehen',
  'tooltip.checkIn': 'Die Person im Land einchecken.',
  'tooltip.consumeRefuse': 'Die Ein- oder Ausreise der Person verweigern.',
  'tooltip.finalRefuse': 'Die endgültige Entscheidung über den Antrag. Die Person darf nicht in das Land einreisen.',
  'tooltip.finalApprove': 'Die endgültige Entscheidung über den Antrag. Die Person darf in das Land ein- oder ausreisen.',
  'tooltip.finalPending': 'Die endgültige Entscheidung über den Antrag. Die Person darf nicht in das Land einreisen, bis der Antrag korrigiert und genehmigt wurde.',
  'tooltip.finalRefuseBlacklist': 'Die endgültige Entscheidung über den Antrag. Die Person darf nicht in das Land einreisen und wird auf die schwarze Liste gesetzt.',
  'photo.entryCountry.IN': 'Bild beim Einchecken',
  'photo.entryCountry.OUT': 'Bild beim Auschecken',
  'supervision.login.error': 'Fehler bei der Überprüfung des Supervisors.',
  'dashboard.noPreviousApplication': 'Es wurden keine vorherigen Anträge gefunden.',
  'err.noPassiveAuthenticationCSCA': 'Das Dokument ist gültig, konnte jedoch nicht von der ausstellenden Behörde überprüft werden.',
  'err.passport.expired': 'Die Gültigkeit des Reisepasses ist abgelaufen.',
  'externalIndexedData': 'Mehrere Reisepässe gefunden',
  'client.extended.chargedBack': 'Dieser Antrag wurde zurückgebucht. Die Person kann dennoch den Check-out durchführen, muss jedoch die Einreisegebühr in bar erneut bezahlen.',
  'ask.chargedBack.confirm': 'Bestätigen Sie, dass die Person die Einreisegebühr erneut bezahlt hat? Wenn Sie dies bestätigen, geben Sie bitte die Zahlungsreferenz und die verwendete Währung ein.',
  'error.payment.noReferenceChargedBack': 'Bitte geben Sie eine Zahlungsreferenz und die verwendete Währung ein.',
  'client.extended.entryChargedBack': 'Dieser Antrag wurde zurückgebucht. Die Person kann den Check-in nicht durchführen und muss einen neuen Einreiseantrag erstellen.',
  'tooltip.syncing': 'Die Anzahl der derzeit synchronisierten Antragsprozesse.',
  'adChoice': 'Verbindung mit Active Directory',
  'external.down': 'Ein Dienst, von dem unsere Anwendung abhängt, funktioniert derzeit nicht. Bitte versuchen Sie es später erneut.',
  'global.connection.server': 'Dienst nicht verfügbar. Entschuldigung für die Unannehmlichkeiten, bitte versuchen Sie es später erneut.',
  'global.connection.problem': 'Fehler beim Hochladen Ihrer Anfrage. Bitte stellen Sie sicher, dass Sie keine VPNs oder Firewalls verwenden, dass Ihre Internetverbindung stabil ist, und versuchen Sie es erneut.',
  'err.passport.issuedSoon': 'Der Reisepass wurde kürzlich ausgestellt (vor weniger als einem Monat).',
  'global.reload': 'Neu laden',
  'error.passportScan': 'CertBytes(b64): <pre>{certBytes}</pre>',
  'glpi.err.noPassiveAuthenticationCSCA': 'Der Zertifikats-Hash des Reisepasses konnte nicht in der ICAO-Masterliste gefunden werden, was zu einem \'err.noPassiveAuthenticationCSCA\'-Fehler führt.',
  'glpi.err.unverifiedDoc': 'Fehler beim Abrufen der Zertifikatsbytes für die passive Authentifizierung; dies führt zu einem \'err.unverifiedDoc\'-Fehler.',
  'glpi.err.noPassiveAuthentication': 'Fehler bei der Durchführung der passiven Authentifizierung; dies führt zu einem \'err.noPassiveAuthentication\'-Fehler.',
  'glpi.err.noConnect': 'Es konnte keine Verbindung mit dem Reisepasschip hergestellt werden, was zu einem \'err.noConnect\'-Fehler führt.',
  'glpi.err.noBAC': 'BAC konnte mit den bereitgestellten MRZ-Informationen nicht hergestellt werden, was zu einem \'err.noBAC\'-Fehler führt.',
  'glpi.err.alteredDoc': 'Die Data Group-Hashes (DGS) sind für einen oder mehrere Einträge falsch, was zu einem \'err.alteredDoc\'-Fehler führt.',
  'glpi.err.revokedDocSigner': 'Die Seriennummer des Dokumentenunterzeichnerzertifikats wurde in der Zertifikatsperrliste (CRL) gefunden, was zu einem \'err.revokedDocSigner\'-Fehler führt.',
  'watchlistCollapse': '<p>Watchlists gefunden - <span class="watchlistCategories">{categories}</span></p>',
  'match.type': 'Übereinstimmungsart',
  'match.hair': 'Haarfarbe',
  'match.eyes': 'Augenfarbe',
  'match.height': 'Größe',
  'match.weight': 'Gewicht',
  'match.race': 'Rasse',
  'global.category': 'Kategorie',
  'watchlist.alertLevel': 'Alarmstufe der Watchlist',
  'watchlist.match': 'Übereinstimmung {numberMatch} | <span class="watchlistCategories">{matchCategory}</span>',
  'Nationalities': 'Nationalität {index}',
  'global.score': 'Punktzahl',
  'watchlist.name': 'Name der Watchlist',
  'alias': 'Alias {index}',
  'document.number': 'Dokumentnummer {index}',
  'document.issuer': 'Aussteller des Dokuments {index}',
  'document.type': 'Dokumentart {index}',
  'dateOfBirth': 'Geburtsdatum {index}',
  'watchlist.marks': 'Merkmale',
  'watchlist.image.link': 'Link zum gefundenen Bild {index}',
  'image.match': 'Übereinstimmendes Bild {index}',
  'tooltip.watchlist': 'Die gefundenen Watchlist-Informationen zu dieser Person.',
  'watchList.category': 'Kategorie der Watchlist',
  'watchlist.level': 'Alarmstufe',
  'scan.fingerprint.desc': 'Wenn Sie bereit sind, klicken Sie auf die Schaltfläche unten, um den Prozess der Fingerabdrucknahme der Person zu starten. Die Person muss ihren Zeigefinger auf den Scanner legen, wenn das rote Licht des Fingerabdruckgeräts aufleuchtet, wie es der Beamte anzeigt.',
  'scan.fingerprint.noResponse': 'Keine Antwort vom Fingerabdruckscanner. Hat die Person ihren Finger auf den Scanner gelegt? Ist das Gerät ordnungsgemäß angeschlossen?',
  'scan.fingerprint': 'Fingerabdruck',
  'fingerprint.scan.start': 'Fingerabdruck scannen',
  'scan.fingerprint.success': 'Die Fingerabdrücke wurden erfolgreich gescannt. Die Qualität des gescannten Fingerabdrucks beträgt {quality}/100. Sie können den Vorgang wiederholen, wenn die Qualität nicht ausreichend ist.',
  'fingerprint.notAvailable': 'Es scheint, dass der Fingerabdruckscanner nicht verfügbar ist oder die Treiber nicht installiert sind. Sie können den Check-in dennoch ohne die Fingerabdrücke fortsetzen.',
  'skip': 'Überspringen',
  'global.checkOut.fingerprint': 'Check-out mit Fingerabdruck',
  'global.checkIn.fingerprint': 'Check-in mit Fingerabdruck',
  'tooltip.checkOut.fingerprint': 'Die Person mit dem Fingerabdruck aus dem Land auschecken.',
  'tooltip.checkIn.fingerprint': 'Die Person mit dem Fingerabdruck im Land einchecken.',
  'paymentError.title': 'Problem mit Ihrer Bestellung',
  'DYN.paymentError.desc.fail': 'Leider ist die Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  'DYN.paymentError.desc.error': 'Leider gab es einen Fehler bei der Zahlungsabwicklung. Bitte kontaktieren Sie uns.',
  'DYN.paymentError.desc.later': 'Leider wurde die Zahlungsabwicklung vorübergehend abgelehnt. Bitte versuchen Sie es erneut.',
  'tooltip.applicationId': 'Die ID des Antrags.',
  'client.extended.missingResource': 'Die von Ihnen angeforderte Ressource ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
  'skip.valid': 'Bereits überprüfte Schritte automatisch überspringen',
  'extension.data': 'Verlängerungsdaten',
  'attestantAddress': 'Adresse des Attestanten',
  'attestantEmail': 'E-Mail des Attestanten',
  'attestantID': 'ID des Attestanten',
  'attestantName': 'Name des Attestanten',
  'attestantPhone': 'Telefonnummer des Attestanten',
  'attestantRelation': 'Beziehung zum Attestanten',
  'daysRequested': 'Anzahl der angeforderten Tage',
  'tooltip.visaApplicationReference': 'Zum mit diesem Verlängerungsantrag verknüpften Antrag gehen',
  'extend.visaReference': 'Antrag, der mit diesem Verlängerungsantrag verknüpft ist',
  'data.copyOfEntry': 'Kopie des Eintrags',
  'data.departureTicket': 'Abreiseticket',
  'data.attestantDocument': 'Dokument des Attestanten',
  'data.affidavitCustody': 'Sorgerechtsbescheinigung',
  'reasonForExtention': 'Grund für die Verlängerung',
  'final.ZWEVISAEXTAB': 'Dieser Verlängerungsantrag muss vom Beamten genehmigt werden.',
  'zwevisaExtValid': 'Verlängerung validiert',
  'zwevisaExtValid.desc': 'Dieser Verlängerungsantrag wurde vom Beamten validiert.',
  'zwevisaExtC.review.state': 'Überprüfung ausstehend',
  'zwevisaExtC.review.desc': 'Dieser Verlängerungsantrag wartet auf Überprüfung.',
  'zwevisaExtC.finalReview.desc': 'Dieser Verlängerungsantrag wurde überprüft und wartet derzeit auf die endgültige Überprüfung.',
  'zwevisaExtC.finalReview.state': 'Endgültige Überprüfung ausstehend',
  'tooltip.tableLocalUsageUntil': 'Das Ablaufdatum des Antrags bezieht sich auf das maximale Enddatum des Aufenthalts.',
  'ask.localUsageUntil.confirm': 'Hier können Sie das maximale Enddatum des Aufenthalts ändern. Sie können das Datum nur verkürzen.',
  'localUsageUntil.ask': 'Maximales Enddatum des Aufenthalts ändern (optional)',
  'error.bad.localUsageUntil': 'Das maximale Enddatum des Aufenthalts muss vor dem aktuellen Ablaufdatum und nach heute liegen.',
  'none': 'Keines',
  'change.password.ad': 'Da Sie über ein Active Directory-Konto verfügen, können Sie Ihr Passwort hier nicht ändern. Für weitere Informationen wenden Sie sich bitte an den Support.',
  'noticePrint.title': 'Informationen der an den Besucher gedruckten Mitteilung',
  'reportingPost': 'Meldeposten',
  'noticePrint.matTooltip': 'Informationen der an den Besucher während des Check-in-Prozesses gedruckten Mitteilung',
  'notice.confirm': 'Sind Sie sicher über die Informationen auf der Mitteilung?',
  'global.refusePrint': 'Drucken und einreichen',
  'global.nextPrint': 'Drucken und fortfahren',
  'err.periodFrom.periodFromGreaterThanPeriodTo': 'Der Zeitraum "Von" muss vor dem Zeitraum "Bis" liegen.',
  'payment.reject_reason': 'Ablehnungsgrund',
  'err.fileSize': 'Dateigröße ist zu groß. Maximale Größe ist: {size}',
  'document.zafembpass': 'ZAF Botschaftspass',
  'preenroll': 'Vorregistrierung',
  'screen': 'Screening',
  'pass': 'Reisepass',
  'document.pass': 'Reisepass',
  'document.screen': 'Screening',
  'payment.ask.print': 'Ist die Quittung gedruckt?',
  'global.no.retry': 'Nein (erneut versuchen)',
  'print.receipt': 'Quittung drucken',
  'tooltip.printReceipt': 'Die Quittung(en) des Antrags drucken',
  'ask.printReceipt': 'Möchten Sie die Quittung vom <b>{date}</b> drucken?',
  'error.printReceipt': 'Beim Drucken der Quittung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  'ask.selectReceipt': 'Bitte wählen Sie die Quittung, die Sie drucken möchten.',
  'operation.OUT': 'Auschecken',
  'operation.IN': 'Einchecken',
  'operation.PAYMENT_FINALIZED': 'Zahlung abgeschlossen',
  'operation.PAYMENT_CREATED': 'Zahlung erstellt',
  'operation.PAYMENT_USED_FORCE': 'Zahlung wurde zwangsweise verwendet',
  'noChoice.selectedReceipt': 'Bitte wählen Sie eine Quittung zum Drucken aus.',
  'select.receipt': 'Quittung auswählen',
  'receiptFor.alt': 'Quittung für',
  'paymentType': 'Zahlungsmethode',
  'totalAmount.alt': 'Gesamtbetrag',
  'totalAmount': 'Gesamtbetrag',
  'date': 'Datum',
  'client': 'Kunde',
  'desc': 'Beschreibung',
  'details': 'Details',
  'client.extended.minUsageNotMet': 'Das Gültigkeitsdatum bis muss mindestens einen Tag nach dem Gültigkeitsdatum ab liegen.',
  'payment.assigned.warning': 'Dieser Antrag wird derzeit von einem anderen Beamten (Beamter: {officerId}) aktiv bearbeitet. Möchten Sie diesen Antrag trotzdem öffnen?',
  'lock': 'Sperren',
  'tooltip.tableLockTitle': 'Aktive Nutzung durch Beamte',
  'client.extended.uuidNotPaid': 'Die Zahlung wurde noch nicht validiert. Bitte validieren Sie die Zahlung, bevor Sie fortfahren.',
  'form.operationComments': 'Begründung der Operation',
  'borderPass.emit': 'Grenzpass ausgestellt',
  'tooltip.borderPass': 'Der Grenzpass ist ein Dokument, das es einer Person ermöglicht, die Grenze zu überqueren. Es wird verwendet, wenn die Person keinen Reisepass besitzt.',
  'zweexit.title': 'Ausreise ohne Visum',
  'borderPass.title': 'Grenzpass',
  'print.borderPass': 'Grenzpass drucken',
  'print.borderPass.ask': 'Ist der Grenzpass gedruckt?',
  'err.issueDate.afterExpiryDate': 'Das Ausstellungsdatum muss vor dem Ablaufdatum liegen.',
  'err.BirthDay.afterExpiryDate': 'Das Geburtsdatum muss vor dem Ablaufdatum liegen.',
  'err.BirthDay.afterIssueDate': 'Das Geburtsdatum muss vor dem Ausstellungsdatum liegen.',
  'apiPnrCollapse': 'PNR gefunden',
  'apipnrResponse.match': 'Übereinstimmung {numberMatch}',
  'match.name': 'Name',
  'match.score.name': 'Punktzahl des Namens',
  'match.flightCarrier': 'Fluggesellschaft',
  'match.flightNumber': 'Flugnummer',
  'match.documentType': 'Dokumentart',
  'match.documentNumber': 'Dokumentennummer',
  'match.documentIssuer': 'Aussteller des Dokuments',
  'match.timeType': 'Ereignistyp',
  'match.timeDate': 'Datum des Ereignisses',
  'match.timeScope': 'Umfang des Ereignisses',
  'match.nationality': 'Nationalität',
  'match.gender': 'Geschlecht',
  'match.uuid': 'UUID',
  'match.travelerUUID': 'Reisender UUID',
  'tooltip.apiPnr': 'Die gefundenen PNR-Informationen zu dieser Person.',
  'match.documentIssued': 'Ausstellungsdatum des Dokuments',
  'match.placeIssued': 'Ort der Ausstellung des Dokuments',
  'match.documentExpiration': 'Ablaufdatum des Dokuments',
  'match.documentScore': 'Punktzahl des Dokuments',
  'match.timeScore': 'Punktzahl des Ereignisses',
  'match.flightOriginDomestic': 'Inländischer Abflugort des Fluges',
  'match.flightOriginIcao': 'ICAO des Abflugortes',
  'match.flightOriginLat': 'Breitengrad des Abflugortes',
  'match.flightOriginLng': 'Längengrad des Abflugortes',
  'match.flightOriginIata': 'IATA des Abflugortes',
  'match.flightOriginCity': 'Stadt des Abflugortes',
  'match.flightOriginState': 'Bundesstaat des Abflugortes',
  'match.flightOriginCountry': 'Land des Abflugortes',
  'match.flightOriginContinent': 'Kontinent des Abflugortes',
  'match.flightOriginName': 'Name des Abflugortes',
  'match.flightOriginTimezone': 'Zeitzone des Abflugortes',
  'match.flightDestinationDomestic': 'Inländischer Zielort des Fluges',
  'match.flightDestinationIcao': 'ICAO des Zielortes',
  'match.flightDestinationLat': 'Breitengrad des Zielortes',
  'match.flightDestinationLng': 'Längengrad des Zielortes',
  'match.flightDestinationIata': 'IATA des Zielortes',
  'match.flightDestinationCity': 'Stadt des Zielortes',
  'match.flightDestinationState': 'Bundesstaat des Zielortes',
  'match.flightDestinationCountry': 'Land des Zielortes',
  'match.flightDestinationContinent': 'Kontinent des Zielortes',
  'match.flightDestinationName': 'Name des Zielortes',
  'match.flightDestinationTimezone': 'Zeitzone des Zielortes',
  'match.localDepartureDate': 'Lokales Abflugdatum',
  'match.localDepartureTime': 'Lokale Abflugzeit',
  'match.localDepartureTotalMinutes': 'Lokale Abflugsminuten insgesamt',
  'match.localDepartureDay': 'Lokaler Abflugtag',
  'match.localDepartureZone': 'Lokale Abflugzone',
  'match.airportDepartureDate': 'Flughafen-Abflugdatum',
  'match.airportDepartureTime': 'Flughafen-Abflugzeit',
  'match.airportDepartureTotalMinutes': 'Flughafen-Abflugsminuten insgesamt',
  'match.airportDepartureDay': 'Flughafen-Abflugtag',
  'match.airportDepartureZone': 'Flughafen-Abflugzone',
  'match.utcDepartureDate': 'UTC-Abflugdatum',
  'match.utcDepartureTime': 'UTC-Abflugzeit',
  'match.utcDepartureTotalMinutes': 'UTC-Abflugsminuten insgesamt',
  'match.utcDepartureDay': 'UTC-Abflugtag',
  'match.utcDepartureZone': 'UTC-Abflugzone',
  'match.originalDeparture': 'Ursprünglicher Abflug',
  'match.flightDepartureUtcstr': 'Abflug UTC des Fluges',
  'match.localArrivalDate': 'Lokales Ankunftsdatum',
  'match.localArrivalTime': 'Lokale Ankunftszeit',
  'match.localArrivalTotalMinutes': 'Lokale Ankunftsminuten insgesamt',
  'match.localArrivalDay': 'Lokaler Ankunftstag',
  'match.localArrivalZone': 'Lokale Ankunftszone',
  'match.airportArrivalDate': 'Flughafen-Ankunftsdatum',
  'match.airportArrivalTime': 'Flughafen-Ankunftszeit',
  'match.airportArrivalTotalMinutes': 'Flughafen-Ankunftsminuten insgesamt',
  'match.airportArrivalDay': 'Flughafen-Ankunftstag',
  'match.airportArrivalZone': 'Flughafen-Ankunftszone',
  'match.utcArrivalDate': 'UTC-Ankunftsdatum',
  'match.utcArrivalTime': 'UTC-Ankunftszeit',
  'match.utcArrivalTotalMinutes': 'UTC-Ankunftsminuten insgesamt',
  'match.utcArrivalDay': 'UTC-Ankunftstag',
  'match.utcArrivalZone': 'UTC-Ankunftszone',
  'match.originalArrival': 'Ursprüngliche Ankunft',
  'match.flightArrivalUtcstr': 'Ankunft UTC des Fluges',
  'match.flightBound': 'Flugrichtung',
  'ask.notice': 'Eine Mitteilung an den Besucher oder eine vorläufige Einschränkungsmitteilung drucken',
  'tooltip.checkIn.notice': 'Checken Sie die Person im Land ein und drucken Sie die Mitteilung an den Besucher oder eine vorläufige Einschränkungsmitteilung.',
  'global.checkIn.notice': 'Check-in mit einer Mitteilung',
  'event.downgrade': 'Dieser Antrag wurde von <b>{previousPayment}</b> auf <b>{newPayment}</b> am {date} vom Benutzer <b>{userId}</b> herabgestuft.',
  'form.numberPeople': 'Anzahl der mit dem Antragsteller reisenden Personen',
  'feedbackForm': 'Feedbackformular',
  'form.totalSpend': 'Gesamtausgaben während des Aufenthalts',
  'countryPermanentResidence': 'Land des ständigen Wohnsitzes',
  'form.feedbackComments': 'Zusätzliche Kommentare',
  'feedback.submit': 'Feedback absenden',
  'feedback.submitted': 'Das Feedback wurde erfolgreich eingereicht.',
  'residencePermit.warning': 'Aufenthaltstitelnummer <b>{permitNumber}</b> wurde nicht in der Datenbank gefunden.<br><br>Bitte überprüfen Sie diese Nummer manuell mit dem physischen Aufenthaltstitel des Reisenden, bevor Sie die Einreise genehmigen.',
  'statusLabel.toConfirm': '(zu bestätigen)',
  'form.lang.IT': 'Italiano',
  'form.lang.JA': '日本語',
  'form.birthCity': 'Geburtsstadt',
  'form.eyeColor': 'Augenfarbe',
  'form.hairColor': 'Haarfarbe',
  'form.height': 'Größe',
  'form.occupation': 'Beruf',
  'form.fatherFirstName': 'Vorname des Vaters',
  'form.fatherLastName': 'Nachname des Vaters',
  'form.motherFirstName': 'Vorname der Mutter',
  'form.motherLastName': 'Nachname der Mutter',
  'form.physical.description': 'Körperliche Beschreibung',
  'documents.no.documents': 'Es wurden keine Dokumente für diese Anwendung gefunden',
  'OtherPurpose': 'Andere Zweck',
  'form.seniority.ownPlace': 'Nur eigene Wohnung',
  'form.seniority.allPlaces': 'Alle Orte',
  'nav.searchFromDocument': 'Suche aus Dokument',
  'tooltip.nextApplication': 'Laden Sie die nächste Anwendung, die verarbeitet werden muss',
  'nextApplication.button': 'Nächste Anwendung verarbeiten',
  'error.insufficientPermissions': 'Unzureichende Berechtigungen für den Zugriff auf diese Funktion',
  'nextApplication.noMore': 'Keine weiteren Anwendungen zu verarbeiten',
  'nextApplication.error': 'Fehler beim Laden der nächsten Anwendung',
  'document.Preview': 'Vorschau',
  'traveller.history.title': 'Reisehistorie',
  'traveller.history.loading': 'Historie wird geladen…',
  'traveller.history.entry_exit': 'Ein- / Ausreise',
  'traveller.history.compliance': 'Compliance',
  'traveller.history.view_more': 'Mehr anzeigen',
  'traveller.history.collapse': 'Einklappen',
  'traveller.history.no_records': 'Keine Einträge gefunden',
  'traveller.history.records': 'Einträge',
  'traveller.history.user': 'Benutzer',
  'traveller.history.reason': 'Grund',
  'traveller.history.additional_info': 'Zusätzliche Informationen',
  'traveller.history.event.ENTERED_COUNTRY': 'Einreise',
  'traveller.history.event.EXITED_COUNTRY': 'Ausreise',
  'traveller.history.event.DEPORTATION_CREATED': 'Abschiebung erstellt',
  'traveller.history.event.DEPORTATION_EDITED': 'Abschiebung bearbeitet',
  'traveller.history.event.DEPORTATION_APPROVED_BY_SUPERVISOR': 'Abschiebung vom Vorgesetzten genehmigt',
  'traveller.history.event.DEPORTATION_APPROVED_BY_DIR_OPS': 'Abschiebung vom Dir. Ops genehmigt',
  'traveller.history.event.SUCCESSFULLY_DEPORTED': 'Erfolgreich abgeschoben',
  'traveller.history.event.DEPORTATION_DECLINED': 'Abschiebung abgelehnt',
  'traveller.history.event.ADDED_TO_WATCHLIST': 'Zur Überwachungsliste hinzugefügt',
  'traveller.history.event.REMOVED_FROM_WATCHLIST': 'Von der Überwachungsliste entfernt',
  'traveller.history.event.PROSECUTION_CREATED': 'Strafverfolgung erstellt',
  'traveller.history.event.ADDED_BIOMETRIC': 'Biometrie hinzugefügt',
  'traveller.history.event.INTERVIEW_CREATED': 'Interview erstellt',
  'traveller.history.event.INTERVIEW_EDITED': 'Interview bearbeitet',
  'traveller.history.event.REFUGEE_RECORD_CREATED': 'Flüchtlingsakte erstellt',
  'traveller.history.event.REFUGEE_RECORD_EDITED': 'Flüchtlingsakte bearbeitet',
  'traveller.history.visa': 'Visum',
  'traveller.history.event.VALIDATED': 'Genehmigt',
  'traveller.history.event.REFUSED': 'Abgelehnt',
  'traveller.history.permits': 'Genehmigungen',
  'traveller.history.permit.ORDINARY_RESIDENCE_PERMIT': 'Gewöhnliche Aufenthaltsgenehmigung',
  'traveller.history.permit.SPOUSE_RESIDENCE_PERMIT': 'Ehegatten-Aufenthaltsgenehmigung',
  'traveller.history.permit.INVESTOR_RESIDENCE_PERMIT': 'Investoren-Aufenthaltsgenehmigung',
  'traveller.history.permit.STUDENTS_PERMIT': 'Studierendengenehmigung',
  'traveller.history.permit.SCHOLARS_PERMIT': 'Schülergenehmigung',
  'traveller.history.permit.TEMPORARY_EMPLOYMENT_PERMIT': 'Temporäre Arbeitsgenehmigung',
  'traveller.history.permit.AUTHORITY_TO_WORK': 'Arbeitserlaubnis',
  'traveller.history.permit.RESUMPTION': 'Wiederaufnahme',
  'traveller.history.permit.DUAL_CITIZENSHIP': 'Doppelte Staatsbürgerschaft',
  'traveller.history.permit.REINSTATEMENT': 'Wiedereinsetzung',
  'traveller.history.permit.applicationType': 'Antragsart',
  'traveller.history.permit.appType.INITIAL': 'Erstantrag',
  'traveller.history.permit.appType.EXTENSION': 'Verlängerung',
  'traveller.history.permit.appType.PERMANENT': 'Dauerhaft',
  'traveller.history.permit.status.REQUESTED': 'Beantragt',
  'traveller.history.permit.status.APPROVED': 'Genehmigt',
  'traveller.history.permit.status.REJECTED': 'Abgelehnt',
  'traveller.history.permit.issueDate': 'Ausstellungsdatum',
  'traveller.history.permit.expiryDate': 'Ablaufdatum',
  'showcase.heroTitle': 'Schnell, sicher & <em>digital</em><br/>eVisa-Erlebnis.',
  'showcase.heroSubtitle': 'Beantragen, verifizieren und in Minuten reisen. {name} kombiniert biometrische Identität mit einer behördlichen Entscheidungsmaschine — damit Ihre Genehmigung vor Ihnen ankommt.',
  'showcase.heroSubtitle.evisa': 'Beantragen, verifizieren und in Minuten reisen. {name} kombiniert biometrische Identität mit einer behördlichen Entscheidungsmaschine — damit Ihre Genehmigung vor Ihnen ankommt.',
  'showcase.heroSubtitle.passport_idCard_residencePermit': 'Stellen Sie Ihren Antrag auf Reisepass, Personalausweis oder Aufenthaltstitel online. {name} bearbeitet und verfolgt jeden Antrag in Echtzeit, von der Einreichung bis zur Lieferung.',
  'showcase.heroSubtitle.passport_idCard': 'Beantragen Sie Reisepass oder Personalausweis online. {name} bearbeitet und verfolgt jeden Antrag in Echtzeit.',
  'showcase.heroSubtitle.passport': 'Beantragen Sie Ihren Reisepass online. {name} bearbeitet und verfolgt jeden Antrag in Echtzeit.',
  'showcase.heroSubtitle.idCard': 'Beantragen Sie Ihren Personalausweis online. {name} bearbeitet und verfolgt jeden Antrag in Echtzeit.',
  'showcase.heroSubtitle.residencePermit': 'Beantragen Sie Ihren Aufenthaltstitel online. {name} bearbeitet und verfolgt jeden Antrag in Echtzeit.',
  'showcase.heroSubtitle.passport_residencePermit': 'Beantragen Sie Reisepass oder Aufenthaltstitel online. {name} bearbeitet und verfolgt jeden Antrag in Echtzeit.',
  'showcase.heroSubtitle.idCard_residencePermit': 'Beantragen Sie Personalausweis oder Aufenthaltstitel online. {name} bearbeitet und verfolgt jeden Antrag in Echtzeit.',
  'showcase.heroCta1': 'eVisa beantragen',
  'showcase.heroCta2': 'Antrag verfolgen',
  'showcase.flowTitleMain': 'Vier Schritte.<br/><em>Keine Warteschlangen.</em>',
  'showcase.flowTitleSub': 'Ein Antrag, der mit Ihnen reist.',
  'showcase.flowSubtitle': '{name} koordiniert die vier Teile Ihres Antrags in einer einzigen flüssigen Bewegung, das System erledigt den Papierkram, während Sie packen.',
  'showcase.ctaTitle': 'Beginnen Sie Ihre Reise<br/><em>digital.</em>',
  'showcase.ctaSubtitle': 'Ein Antrag. Ein eVisa in Ihrer Tasche und eine Entscheidung, die vor Ihnen ankommt.',
  'showcase.step1.label': 'Antrag erstellen',
  'showcase.step1.paneTitle': 'Ihre Daten ausfüllen',
  'showcase.step1.paneDesc': 'Ziel, Reisedaten, Reisezweck und Einreiseort…',
  'showcase.step2.label': 'Dokumente hochladen',
  'showcase.step2.paneTitle': 'Reisepass hochladen',
  'showcase.step2.paneDesc': 'Passscan, MRZ-Lesung, sofortige Feldextraktion…',
  'showcase.step3.label': 'Biometrische Verifizierung',
  'showcase.step3.paneTitle': 'Lebenderkennung & Gesichtsabgleich',
  'showcase.step3.paneDesc': 'Liveness-Check, Gesichtsabgleich und Sanktionsprüfung…',
  'showcase.step4.label': 'Sofortige Genehmigung',
  'showcase.step4.paneTitle': 'Genehmigt & grenzbereit',
  'showcase.step4.paneDesc': 'Ihr eVisa ist signiert, versiegelt und mit Ihrer Geldbörse synchronisiert…',
  'showcase.stat1.value': 'Verschlüsselt',
  'showcase.stat1.label': 'Ende-zu-Ende',
  'showcase.stat2.value': 'Zertifiziert',
  'showcase.stat2.label': 'sichere Plattform',
  'showcase.portalType': 'eVisa-Portal',
  'showcase.tl.step1': 'Identität',
  'showcase.tl.step3': 'Entscheidung',
  'showcase.tl.step4': 'Reise',
  'showcase.tl.step2': 'Dokumente',
  'showcase.evisa.ministry': 'MINISTERIUM FÜR AUSWÄRTIGE ANGELEGENHEITEN',
  'showcase.marquee.issuedBy': 'Ausgestellt von Staatsbehörden',
  'showcase.marquee.biometric': 'Biometrisch',
  'showcase.marquee.secured': 'Gesichert',
  'showcase.marquee.borderReady': 'Grenzbereit in Minuten',
  'showcase.marquee.encrypted': 'Ende-zu-Ende verschlüsselt',
  'showcase.marquee.eSeal': 'Qualifiziertes elektronisches Siegel',
  'showcase.marquee.realtime': 'Echtzeit-Verfolgung',
  'showcase.annot.mrz': 'MRZ verifiziert',
  'showcase.annot.biometric': 'Biometrisch',
  'showcase.annot.issued': 'Ausgestellt',
  'showcase.annot.secured': 'Gesichert',
  'showcase.howItWorks': 'So funktioniert es',
  'showcase.signIn': 'In mein Konto einloggen',
  'showcase.scroll': 'Scrollen',
  'showcase.permit.badge': 'EINWOHNER',
  'showcase.permit.title': 'ERLAUBNIS',
  'showcase.permit.name': 'Aufenthaltskarte',
  'finger.thumb': 'Daumen',
  'finger.index': 'Zeigefinger',
  'finger.middle': 'Mittelfinger',
  'finger.ring': 'Ringfinger',
  'finger.little': 'Kleiner Finger',
  'finger.missing': 'Fehlend',
  'hand.left': 'Linke Hand',
  'hand.right': 'Rechte Hand',
  'fingerprints': 'Fingerabdrücke',
  'finger.thumbs': 'Daumen',
  'fingers.missing': 'Fehlende Finger',
  'signature': 'Unterschrift',
  'print.withdrawal.date': 'Abhebungsdatum',
  'trips.helper': 'Klicken Sie, um den QR-Code anzuzeigen/herunterzuladen'
};
